import LangKeys from "./keys";

const gu = {
  [LangKeys.reminders_collect_faster]: "3 ગણી ઝડપે નાણાં વસૂલો",
  [LangKeys.reminders_total_dues]: "કુલ બાકી રકમ",
  [LangKeys.reminders_all_customers]: "બધા ગ્રાહકો",
  [LangKeys.reminders_all]: "બધા",
  [LangKeys.reminders_customers]: "ગ્રાહકો",
  [LangKeys.reminders_suppliers]: "વેપારીઓ",
  [LangKeys.reminders_search_placeholder]: "ગ્રાહકનું નામ અથવા મોબાઈલ શોધો...",
  [LangKeys.reminders_pending_balance]: "બાકી રકમ",
  [LangKeys.reminders_sent]: "મોકલાયું",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "કોલ કરો",
  [LangKeys.reminders_date]: "તારીખ",
  [LangKeys.reminders_all_up_to_date]: "બધું અપ-ટૂ-ડેટ છે",
  [LangKeys.reminders_no_overdue_heading]: "કોઈ મુદત વીતેલ ગ્રાહક મળ્યા નથી",
  [LangKeys.reminders_no_overdue_sub]: "સરસ! બધા ગ્રાહકોની બાકી રકમ હાલમાં અપ-ટૂ-ડેટ છે.",
  [LangKeys.reminders_view_all_customers]: "બધા ગ્રાહકો જુઓ",
  [LangKeys.reminders_no_due_today_heading]: "આજે કોઈ ગ્રાહકની બાકી રકમ નથી",
  [LangKeys.reminders_no_due_today_sub]: "આજ માટે કોઈ પેમેન્ટ રીમાઇન્ડર નિર્ધારિત નથી.",
  [LangKeys.reminders_no_upcoming_heading]: "કોઈ આગામી રીમાઇન્ડર નથી",
  [LangKeys.reminders_no_upcoming_sub]: "સમયસર સ્વચાલિત રીમાઇન્ડર મોકલવા માટે કલેક્શન તારીખ સેટ કરો.",
  [LangKeys.reminders_no_customers_found]: "કોઈ ગ્રાહક મળ્યા નથી",
  [LangKeys.reminders_no_customers_matched]: "તમારી શોધ સાથે કોઈ ગ્રાહક મળ્યા નથી.",
  [LangKeys.reminders_auto_reminder_active]: "ઓટો રીમાઇન્ડર સક્રિય",
  [LangKeys.reminders_overdue_by]: "બાકી મુદત",
  [LangKeys.reminders_due_in]: "બાકી દિવસ",
  [LangKeys.reminders_days]: "દિવસ",
  [LangKeys.reminders_day]: "દિવસ",
  [LangKeys.reminders_set_collection_date]: "કલેક્શન તારીખ સેટ કરો",
  [LangKeys.reminders_collect_faster_sub]: "ગ્રાહકો પાસેથી ઝડપથી નાણાં મેળવો",
  [LangKeys.reminders_pending_amount_filter]: "બાકી રકમ ફિલ્ટર (₹)",
  [LangKeys.reminders_highest_amount]: "સૌથી વધુ રકમ",
  [LangKeys.reminders_oldest_dues]: "સૌથી જૂની બાકી રકમ",
  [LangKeys.reminders_by_due_date]: "તારીખ મુજબ",
  [LangKeys.reminders_min]: "ન્યૂનતમ",
  [LangKeys.reminders_max]: "મહત્તમ",
  [LangKeys.reminders_to]: "થી",
  [LangKeys.reminders_customers_selected]: "ગ્રાહકો પસંદ કર્યા",
  [LangKeys.reminders_total]: "કુલ",
  [LangKeys.reminders_set_due_date_selected]: "પસંદ કરેલ ગ્રાહકોની તારીખ નક્કી કરો",
  [LangKeys.reminders_date_lbl]: "તારીખ",
  [LangKeys.reminders_wa_sent_toast]: "{name} ને WhatsApp રીમાઇન્ડર મોકલાયું!",
  [LangKeys.reminders_date_updated]: "રીમાઇન્ડર તારીખ સફળતાપૂર્વક સાચવવામાં આવી!",

  [LangKeys.reminders_bulk_success]: "સફળતાપૂર્વક રિમાઇન્ડર મોકલવામાં આવ્યું!",

  [LangKeys.reminders_sending]: "સાચવી રહ્યું છે...",

  [LangKeys.reminders_cloud_wa]: "ક્લાઉડ WhatsApp API (ઓટો)",

  [LangKeys.reminders_direct_wa]: "સીધું WhatsApp (વેબ/એપ)",

  [LangKeys.reminders_no_pending_desc]: "જ્યારે કોઈ ગ્રાહક પાસેથી પૈસા લેવાના હશે, ત્યારે તેઓ અહીં રિમાઇન્ડર યાદીમાં દેખાશે.",

  [LangKeys.reminders_no_pending]: "કોઈ પેન્ડિંગ રિમાઇન્ડર નથી",

  [LangKeys.reminders_clear_date]: "તારીખ હટાવો",

  [LangKeys.reminders_save_date]: "તારીખ સાચવો",

  [LangKeys.reminders_time_lbl]: "સમય",

  [LangKeys.reminders_chip_custom]: "કસ્ટમ તારીખ",

  [LangKeys.reminders_chip_1month]: "1 મહિના પછી",

  [LangKeys.reminders_chip_15days]: "15 દિવસ પછી",

  [LangKeys.reminders_chip_1week]: "1 અઠવાડિયા પછી",

  [LangKeys.reminders_chip_3days]: "3 દિવસ પછી",

  [LangKeys.reminders_chip_tomorrow]: "આવતીકાલે",

  [LangKeys.reminders_chip_today]: "આજે",

  [LangKeys.reminders_days_left]: "દિવસ બાકી",

  [LangKeys.reminders_days_overdue]: "દિવસ મોડું",

  [LangKeys.reminders_not_sent]: "હજુ સુધી મોકલેલ નથી",

  [LangKeys.reminders_last_sent]: "છેલ્લે મોકલેલ",

  [LangKeys.reminders_auto_reminder_desc]: "નિયત તારીખ અને સમયે આપમેળે રીમાઇન્ડર મોકલો",

  [LangKeys.reminders_auto_reminder]: "ઓટો રીમાઇન્ડર (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "બધાને એકસાથે વોટ્સએપ મોકલો",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp રિમાઇન્ડર મોકલો",

  [LangKeys.reminders_change_due_date]: "તારીખ બદલો",

  [LangKeys.reminders_set_due_date]: "બાકી તારીખ સેટ કરો",

  [LangKeys.reminders_selected]: "પસંદ કરેલ",

  [LangKeys.reminders_select_all]: "બધા પસંદ કરો",

  [LangKeys.reminders_search_hint]: "ગ્રાહકનું નામ અથવા મોબાઇલ શોધો...",

  [LangKeys.reminders_no_date_tab]: "તારીખ વગર",

  [LangKeys.reminders_upcoming_tab]: "આગામી",

  [LangKeys.reminders_overdue_tab]: "ઓવરડ્યુ",

  [LangKeys.reminders_today_tab]: "આજે",

  [LangKeys.reminders_all_tab]: "બધા",

  [LangKeys.reminders_no_date]: "તારીખ વિના",

  [LangKeys.reminders_upcoming]: "આગામી",

  [LangKeys.reminders_due_today]: "આજે બાકી",

  [LangKeys.reminders_overdue]: "મુદત વીતી ગયેલ",

  [LangKeys.reminders_total_outstanding]: "કુલ બાકી રકમ",

  [LangKeys.reminders_subtitle]: "સ્માર્ટ ખાતાવહી સાથે તમારો વ્યવસાય વધારો.",

  [LangKeys.reminders_title]: "પેમેન્ટ રીમાઇન્ડર",

  [LangKeys.processing]: "પ્રક્રિયા ચાલુ છે...",

  [LangKeys.business_owner]: "વેપાર માલિક",

  [LangKeys.moxpal_khata]: "મોક્સપાલ ખાતા",

  [LangKeys.failed_load_dashboard]: "ડેશબોર્ડ ડેટા લોડ કરવામાં નિષ્ફળ",

  [LangKeys.delete_confirm]: "શું તમે ખરેખર કાઢી નાખવા માંગો છો?",

  [LangKeys.today]: "આજે",

  [LangKeys.add_bill_terms_conditions_hint]: "નિયમો અને શરતો...",

  [LangKeys.stock]: "સ્ટોક",

  [LangKeys.add_bill_item_price]: "કિંમત",

  [LangKeys.add_bill_item_name]: "આઇટમનું નામ",

  [LangKeys.parties]: "પાર્ટીઓ",

  [LangKeys.address_area]: "વિસ્તાર / લેન્ડમાર્ક",

  [LangKeys.address_flat_no]: "મકાન / દુકાન નં.",

  [LangKeys.search_items_hint]: "આઇટમ શોધો...",

  [LangKeys.no_items_found]: "કોઈ આઇટમ મળી નથી",

  [LangKeys.loading]: "લોડ થઈ રહ્યું છે...",

  [LangKeys.edit_price_dialog_title]: "કિંમત સંપાદિત કરો",

  [LangKeys.photos]: "ફોટા",

  [LangKeys.notes]: "નોંધો",

  [LangKeys.save_expense]: "ખર્ચ સાચવો",

  [LangKeys.add_bill_payment_details]: "ચુકવણી વિગતો",

  [LangKeys.fields]: "ફીલ્ડ્સ",

  [LangKeys.unpaid]: "બાકી (Unpaid)",

  [LangKeys.item_name_required]: "આઇટમનું નામ આવશ્યક છે",

  [LangKeys.delete_confirmation]: "શું તમે ખરેખર આને કાઢી નાખવા માંગો છો?",

  [LangKeys.online_private]: "ખાનગી (Private)",

  [LangKeys.online_active]: "ઓનલાઇન માર્કેટમાં સક્રિય",

  [LangKeys.app_name]: "મોક્ષપાલ ખાતા",
  [LangKeys.header_subtitle]: "સ્માર્ટ બુકકીપિંગ સાથે તમારા વ્યવસાયને આગળ વધારો.",

  // SHARED KHATA
  [LangKeys.shared_khata__summary]: "ખાતા સારાંશ",
  [LangKeys.customer_name]: "ગ્રાહકનું નામ",
  [LangKeys.mobile_no]: "મોબાઇલ નંબર",
  [LangKeys.transaction_history]: "વ્યવહાર ઇતિહાસ",
  [LangKeys.total_debit]: "કુલ ડેબિટ",
  [LangKeys.total_credit]: "કુલ ક્રેડિટ",
  [LangKeys.net_balance]: "ચોખ્ખી સિલક",
  [LangKeys.date]: "તારીખ",
  [LangKeys.credit]: "જમા",
  [LangKeys.debit]: "ઉધાર",
  [LangKeys.balance]: "સિલક",
  [LangKeys.note]: "નોંધ",
  [LangKeys.call_support]: "સપોર્ટને કૉલ કરો",
  [LangKeys.invalid_link]: "આ લિંક અમાન્ય છે અથવા સમાપ્ત થઈ ગઈ છે.",
  [LangKeys.footer]: "આ કમ્પ્યુટર દ્વારા જનરેટ થયેલ સ્ટેટમેન્ટ છે અને તેને કોઈ સહીની જરૂર નથી.",

  // COMMON
  [LangKeys.settings]: "સેટિંગ્સ",
  [LangKeys.settings_subtitle]: "તમારી એપ્લિકેશન અને વ્યવસાય પસંદગીઓનું સંચાલન કરો",
  [LangKeys.language]: "ભાષા",
  [LangKeys.select_language]: "ભાષા પસંદ કરો",
  [LangKeys.close]: "બંધ કરો",
  [LangKeys.save]: "સાચવો",
  [LangKeys.retry]: "ફરી પ્રયાસ કરો",
  [LangKeys.profile]: "પ્રોફાઇલ સંપાદિત કરો",
  [LangKeys.logout]: "લૉગઆઉટ",
  [LangKeys.version]: "સંસ્કરણ",
  [LangKeys.copyright]: "કૉપિરાઇટ © મૉક્સપાલ ખાતા",
  [LangKeys.total]: "કુલ",
  [LangKeys.required_field]: "આ ફીલ્ડ જરૂરી છે",
  [LangKeys.product]: "ઉત્પાદન",

  [LangKeys.message_language]: "SMS ભાષા",
  [LangKeys.follow_app]: "એપ મુજબ",

  [LangKeys.hindi]: "હિન્દી",
  [LangKeys.english]: "અંગ્રેજી",
  [LangKeys.hinglish]: "હિંગ્લિશ",
  [LangKeys.gujarati]: "ગુજરાતી",
  [LangKeys.marathi]: "મરાઠી",
  [LangKeys.punjabi]: "પંજાબી",
  [LangKeys.tamil]: "તમિલ",
  [LangKeys.telugu]: "તેલુગુ",

  // SETTINGS PAGE
  [LangKeys.business_settings]: "વ્યવસાય સેટિંગ્સ",
  [LangKeys.business_settings_desc]: "વ્યવસાય પ્રોફાઇલ, લોગો અને GST વિગતો",
  [LangKeys.staff_permissions]: "સ્ટાફ અને પરવાનગીઓ",
  [LangKeys.staff_permissions_desc]: "સ્ટાફની ઍક્સેસ અને પરવાનગીઓનું સંચાલન કરો",
  [LangKeys.backup_information]: "બેકઅપ માહિતી",
  [LangKeys.backup_information_desc]: "ખાતા ડેટા નિકાસ અને પુનઃસ્થાપિત કરો",
  [LangKeys.delete_khata]: "ખાતા કાઢી નાખો",
  [LangKeys.delete_khata_desc]: "તમામ વ્યવસાય ડેટા કાયમ માટે દૂર કરો",
  [LangKeys.app_update]: "એપ અપડેટ",
  [LangKeys.app_update_desc]: "નવીનતમ સંસ્કરણ માટે તપાસો",
  [LangKeys.app_up_to_date]: "એપ નવીનતમ છે",
  [LangKeys.failed_to_check_for_update]: "અપડેટ તપાસવામાં નિષ્ફળ ગયું",
  [LangKeys.whatsapp_service]: "વોટ્સએપ એલર્ટ્સ અને ક્રેડિટ્સ",
  [LangKeys.whatsapp_service_desc]: "ગ્રાહકોને આપમેળે પેમેન્ટ રિમાઇન્ડર મોકલો અને ક્રેડિટ્સ મેનેજ કરો",

  // Whatsapp SMS Credits PAGE
  [LangKeys.whatsapp_credits]: "વોટ્સએપ ક્રેડિટ્સ",
  [LangKeys.available_credits]: "ઉપલબ્ધ ક્રેડિટ્સ",
  [LangKeys.whatsapp_balance]: "વોટ્સએપ મેસેજ બેલેન્સ",
  [LangKeys.used]: "ઉપયોગ",
  [LangKeys.credits]: "ક્રેડિટ્સ",
  [LangKeys.proceed_to_pay]: "ચુકવણી કરો",
  [LangKeys.recharge_plans]: "રીચાર્જ પ્લાન્સ",
  [LangKeys.off]: "બંધ",
  [LangKeys.load_failed]: "લોડ નિષ્ફળ ગયું",
  [LangKeys.toggle_failed]: "ટૉગલ નિષ્ફળ ગયું",
  [LangKeys.order_failed]: "ઓર્ડર નિષ્ફળ ગયું",
  [LangKeys.payment_error]: "પેમેન્ટ એરર આવ્યું",
  [LangKeys.payment_failed]: "પેમેન્ટ નિષ્ફળ ગયું",
  [LangKeys.verification_failed]: "વેરિફિકેશન નિષ્ફળ ગયું",
  [LangKeys.recharge_successful]: "રીચાર્જ સફળ થયું",
  [LangKeys.total_purchased]: "કુલ ખરીદેલ",
  [LangKeys.premium_unlimited_active]: "અનલિમિટેડ WhatsApp એલર્ટ્સ સક્રિય છે! 🎉",
  [LangKeys.premium_unlimited_desc]: "તમે Moxpal Khata ના શ્રેષ્ઠ પ્લાન 'Premium Plan 98' ના સક્રિય સભ્ય છો! તમને અનલિમિટેડ ઓટો WhatsApp અને SMS એલર્ટ્સ સંપૂર્ણ મફત આપવામાં આવ્યા છે.",

  // BACKUP INFORMATION
  [LangKeys.backup_info_text]: "જ્યારે તમારો ફોન ઇન્ટરનેટથી કનેક્ટેડ હોય ત્યારે તમારો ડેટા આપમેળે બેકઅપ થઈ જાય છે. જો તમે તમારો ફોન ફોર્મેટ કરો અથવા એપ્લિકેશન કાઢી નાખો, તો ફક્ત તમારા રજિસ્ટર્ડ નંબરનો ઉપયોગ કરીને ફરીથી લૉગ ઇન કરો. તમારો ડેટા આપમેળે પુનઃસ્થાપિત થઈ જશે.",
  [LangKeys.last_backup_at]: "છેલ્લું બેકઅપ",

  // DELETE / KHATA
  [LangKeys.delete_warning_text]: "તમે આ વ્યવસાયને કાઢી નાખવા જઈ રહ્યા છો. તમારો તમામ ડેટા રિસાયકલ બિનમાં ખસેડવામાં આવશે. તમે તેને 30 દિવસની અંદર પુનઃસ્થાપિત કરી શકો છો.",
  [LangKeys.delete_placeholder]: "પુષ્ટિ કરવા માટે વ્યવસાયનું નામ લખો",
  [LangKeys.delete_button]: "કાઢી નાખો",
  [LangKeys.delete_name_mismatch]: "વ્યવસાયનું નામ મેળ ખાતું નથી.",

  // KHATA
  [LangKeys.my_khata]: "મારો ખાતો",
  [LangKeys.search_customer]: "ગ્રાહક શોધો",
  [LangKeys.all_customers]: "બધા ગ્રાહકો",
  [LangKeys.no_customers_found]: "કોઈ ગ્રાહક મળ્યો નથી",
  [LangKeys.no_suppliers_found]: "કોઈ સપ્લાયર મળ્યો નથી",
  [LangKeys.no_parties_found]: "કોઈ પક્ષો મળ્યા નથી",
  [LangKeys.just_now]: "હમણાં જ",
  [LangKeys.min_ago]: "{value} મિનિટ પહેલા",
  [LangKeys.hr_ago]: "{value} કલાક પહેલા",
  [LangKeys.day_ago]: "{value} દિવસ પહેલા",
  [LangKeys.month_ago]: "{value} મહિના પહેલા",
  [LangKeys.year_ago]: "{value} વર્ષ પહેલા",
  [LangKeys.settled]: "હિસાબ બરાબર",
  [LangKeys.advance]: "જમા રકમ",
  [LangKeys.due]: "ઉધાર",
  [LangKeys.no_transactions]: "હજુ સુધી કોઈ લેવડદેવડ નથી",
  [LangKeys.no_entries_yet]: "હજુ સુધી કોઈ એન્ટ્રી નથી",
  [LangKeys.new_label]: "નવું",

  // DASHBOARD / HOME SCREEN
  [LangKeys.khata]: "ખાતું",
  [LangKeys.you_will_get]: "તમારે લેવાના છે",
  [LangKeys.you_will_give]: "તમારે આપવાના છે",
  [LangKeys.search_khata_entry]: "ખાતાની એન્ટ્રી શોધો",
  [LangKeys.recent_entries]: "તાજેતરની એન્ટ્રીઓ",
  [LangKeys.unknown_party]: "અજાણી પાર્ટી",
  [LangKeys.unknown_customer]: "અજાણ્યો ગ્રાહક",
  [LangKeys.unknown]: "અજાણ્યું",

  // CUSTOMER LEDGER
  [LangKeys.ledger]: "ખાતાવહી",
  [LangKeys.report]: "રિપોર્ટ",
  [LangKeys.reminder]: "રિમાઇન્ડર",
  [LangKeys.sms]: "એસએમએસ",
  [LangKeys.whatsapp]: "વોટ્સએપ",
  [LangKeys.outstanding_balance]: "બાકી રકમ",
  [LangKeys.total_balance]: "કુલ સિલક",
  [LangKeys.you_got]: "તમને મળ્યા",
  [LangKeys.you_gave]: "તમે આપ્યા",
  [LangKeys.entries]: "એન્ટ્રીઓ",
  [LangKeys.no_entries_found]: "કોઈ એન્ટ્રીઓ મળી નથી",
  [LangKeys.i_got]: "મને મળ્યા",
  [LangKeys.i_gave]: "મેં આપ્યા",
  [LangKeys.you_got_caps]: "તમને મળ્યા",
  [LangKeys.you_gave_caps]: "તમે આપ્યા",
  [LangKeys.wa_dear]: "પ્રિય",
  [LangKeys.wa_account_update]: "મોક્ષપાલ ખાતા તરફથી તમારા ખાતાનું અપડેટ અહીં છે.",
  [LangKeys.total_due]: "કુલ બાકી રકમ",
  [LangKeys.view_full_account]: "સંપૂર્ણ ખાતાનું સ્ટેટમેન્ટ જુઓ",
  [LangKeys.failed_to_load_data]: "ડેટા લોડ કરવામાં નિષ્ફળ.",
  [LangKeys.could_not_open_whatsapp]: "WhatsApp ખોલી શકાયું નથી.",
  [LangKeys.could_not_open_sms]: "SMS એપ ખોલી શકાયું નથી.",
  [LangKeys.total_purchase]: "કુલ ખરીદી",
  [LangKeys.total_received]: "કુલ પ્રાપ્ત",
  [LangKeys.entry_success]: "એન્ટ્રી સફળ થઈ",
  [LangKeys.transaction_success]: "લેણ-દેણ સફળ થયું",
  [LangKeys.done]: "પૂર્ણ થયું",

  // ENTRY
  [LangKeys.entry_details]: "એન્ટ્રીની વિગતો",
  [LangKeys.running_balance]: "ચાલુ સિલક",
  [LangKeys.share]: "શેર કરો",
  [LangKeys.network_error]: "નેટવર્ક ભૂલ",
  [LangKeys.copy_link]: "લિંક કૉપિ કરો",
  [LangKeys.delete_entry]: "એન્ટ્રી કાઢી નાખો",
  [LangKeys.delete_entry_confirm]: "શું તમે ખરેખર આ એન્ટ્રી કાઢી નાખવા માંગો છો?",
  [LangKeys.delete_entry_warning]: "આ ક્રિયા પૂર્વવત્ કરી શકાતી નથી.",
  [LangKeys.edit_entry]: "એન્ટ્રીમાં ફેરફાર કરો",
  [LangKeys.invalid_entry]: "અમાન્ય એન્ટ્રી",
  [LangKeys.entry_not_found]: "એન્ટ્રી મળી નથી",
  [LangKeys.invalid_entry_type]: "અમાન્ય એન્ટ્રી પ્રકાર",
  [LangKeys.invalid_amount]: "અમાન્ય રકમ",
  [LangKeys.invalid_date]: "અમાન્ય તારીખ",
  [LangKeys.photo_size_error]: "ફોટોનું કદ 1MB કરતાં ઓછું હોવું જોઈએ",
  [LangKeys.invalid_image_format]: "આ ફોટો ફોર્મેટ સપોર્ટેડ નથી. કૃપા કરીને JPG, PNG અથવા WEBP ફોટો પસંદ કરો.",
  [LangKeys.photo_upload_failed]: "ફોટો અપલોડ નિષ્ફળ",
  [LangKeys.update_failed]: "અપડેટ નિષ્ફળ",
  [LangKeys.amount]: "રકમ",
  [LangKeys.photo_max]: "ફોટો (મહત્તમ 1MB)",
  [LangKeys.change_photo]: "ફોટો બદલો",
  [LangKeys.add_entry_title]: "એન્ટ્રી ઉમેરો",
  [LangKeys.save_entry]: "એન્ટ્રી સાચવો",
  [LangKeys.photo]: "ફોટો",
  [LangKeys.amount_hint]: "₹ 0",
  [LangKeys.note_hint]: "વૈકલ્પિક નોંધ",
  [LangKeys.add_photo_label]: "📷 ફોટો ઉમેરો",
  [LangKeys.failed_to_add_entry]: "એન્ટ્રી ઉમેરવામાં નિષ્ફળ.",
  [LangKeys.image_too_large_4mb]: "છબી ખૂબ મોટી છે. કૃપા કરીને 4MB હેઠળની છબી પસંદ કરો.",
  [LangKeys.share_coming_soon]: "શેર સુવિધા ટૂંક સમયમાં આવી રહી છે!",
  [LangKeys.image_load_failed]: "છબી લોડ કરવામાં નિષ્ફળ",
  [LangKeys.select_date]: "તારીખ પસંદ કરો",
  [LangKeys.photo_max_2mb]: "ફોટો (મહત્તમ 2MB)",
  [LangKeys.add_to_cashbook]: "કેશબુકમાં પણ ઉમેરો",

  // PDF
  [LangKeys.owner_name]: "માલિકનું નામ",
  [LangKeys.customer_ledger_statement]: "ગ્રાહક ખાતાવહી સ્ટેટમેન્ટ",
  [LangKeys.phone]: "ફોન",
  [LangKeys.opening_balance]: "શરૂઆતની સિલક",
  [LangKeys.closing_balance]: "આખરની સિલક",
  [LangKeys.transaction_details]: "વ્યવહાર વિગતો",
  [LangKeys.particulars]: "વિગતો",
  [LangKeys.credit_short]: "જમા",
  [LangKeys.debit_short]: "ઉધાર",
  [LangKeys.generated_by]: "મોક્ષપાલ ખાતા દ્વારા જનરેટ થયેલ",
  [LangKeys.my_business]: "મારો વ્યવસાય",
  [LangKeys.pdf_generation_error]: "PDF બનાવવામાં ભૂલ",
  [LangKeys.debit_minus]: "ઉધાર (-)",
  [LangKeys.credit_plus]: "જમા (+)",
  [LangKeys.total_paid]: "કુલ ચુકવણી",
  [LangKeys.received]: "મળેલ",
  [LangKeys.paid]: "ચુકવણી",
  [LangKeys.supplier_name]: "સપ્લાયરનું નામ",
  [LangKeys.supplier_report]: "સપ્લાયર રિપોર્ટ",
  [LangKeys.supplier_ledger_statement]: "સપ્લાયર લેજર સ્ટેટમેન્ટ",
  [LangKeys.data_not_available_for_pdf]: "PDF માટે ડેટા ઉપલબ્ધ નથી",

  // ACCOUNT
  [LangKeys.account]: "એકાઉન્ટ",
  [LangKeys.add_business]: "વ્યવસાયની વિગતો ઉમેરો",
  [LangKeys.add_owner]: "માલિકની વિગતો ઉમેરો",
  [LangKeys.business]: "વ્યવસાય",
  [LangKeys.staff]: "સ્ટાફ",
  [LangKeys.items]: "આઇટમ્સ",
  [LangKeys.bills]: "બિલ્સ",
  [LangKeys.dairy]: "ડેરી",
  [LangKeys.cashbook]: "કેશબુક",
  [LangKeys.help_support]: "મદદ અને સપોર્ટ",
  [LangKeys.about_app]: "અમારા વિશે",
  [LangKeys.invite_friends]: "મિત્રોને આમંત્રિત કરો",
  [LangKeys.privacy_policy]: "ગોપનીયતા નીતિ",
  [LangKeys.disclaimer]: "અસ્વીકરણ",
  [LangKeys.share_subject]: "📒 મોક્સપાલ ખાતા એપ",
  [LangKeys.share_message]: "👉 ઉધાર-લેવડદેવડ અને હિસાબ રાખવા માટે હું Moxpal Khata એપ ઉપયોગ કરું છું. આ ખૂબ સરળ અને વિશ્વસનીય એપ છે. 📲 તમે પણ હમણાં જ ડાઉનલોડ કરો અને તમારા ખાતાઓ સરળતાથી મેનેજ કરો: https://khata.moxpal.com/app",

  // STAFF
  [LangKeys.staff_details]: "સ્ટાફની વિગતો",
  [LangKeys.staff_question]: "સ્ટાફ શું છે?",
  [LangKeys.add_staff]: "સ્ટાફ ઉમેરો",
  [LangKeys.staff_name]: "સ્ટાફનું નામ",
  [LangKeys.permissions]: "પરવાનગીઓ",
  [LangKeys.stop_staff]: "સ્ટાફને રોકો",
  [LangKeys.stop_staff_desc]: "આ સ્ટાફ તમારા વ્યવસાય ડેટાને ઍક્સેસ કરી શકશે નહીં.",
  [LangKeys.delete_staff]: "સ્ટાફને કાઢી નાખો",
  [LangKeys.delete_staff_desc]: "આ સ્ટાફ કાયમ માટે કાઢી નાખવામાં આવશે.",
  [LangKeys.add_staff_to_manage]: "મેનેજ કરવા માટે સ્ટાફ ઉમેરો",

  // NAVBAR
  [LangKeys.home]: "હોમ",
  [LangKeys.more]: "વધુ",

  // ADD PARTY
  [LangKeys.add_party]: "પાર્ટી ઉમેરો",
  [LangKeys.address_optional]: "સરનામું (વૈકલ્પિક)",
  [LangKeys.gst_optional]: "GSTIN (વૈકલ્પિક)",
  [LangKeys.add_supplier]: "સપ્લાયર ઉમેરો",
  [LangKeys.name_required]: "નામ જરૂરી છે",
  [LangKeys.edit]: "ફેરફાર કરો",

  // BOOK PROFILE
  [LangKeys.book_profile]: "ખાતા પ્રોફાઇલ બનાવો",
  [LangKeys.personal_info]: "વ્યક્તિગત માહિતી",
  [LangKeys.business_info]: "વ્યવસાય માહિતી",
  [LangKeys.financial_info]: "નાણાકીય માહિતી",
  [LangKeys.staff_info]: "સ્ટાફ માહિતી",
  [LangKeys.name]: "નામ",
  [LangKeys.add_name]: "નામ ઉમેરો",
  [LangKeys.registered_number]: "રજિસ્ટર્ડ મોબાઇલ નંબર",
  [LangKeys.add_mobile]: "મોબાઇલ નંબર ઉમેરો",
  [LangKeys.business_name]: "વ્યવસાયનું નામ",
  [LangKeys.business_address]: "વ્યવસાયનું સરનામું",
  [LangKeys.add_address]: "સરનામું ઉમેરો",
  [LangKeys.gstin]: "GSTIN",
  [LangKeys.bank_account]: "બેંક ખાતું",
  [LangKeys.add_details]: "વિગતો ઉમેરો",
  [LangKeys.details]: "વિગતો",
  [LangKeys.add_photo]: "ફોટો ઉમેરો",
  [LangKeys.profile_strength]: "પ્રોફાઇલ મજબૂતી",
  [LangKeys.customer_profile]: "ગ્રાહક પ્રોફાઇલ",
  [LangKeys.supplier_profile]: "સપ્લાયર પ્રોફાઇલ",
  [LangKeys.address]: "સરનામું",
  [LangKeys.type]: "પ્રકાર",
  [LangKeys.customer]: "ગ્રાહક",
  [LangKeys.supplier]: "સપ્લાયર",
  [LangKeys.delete_customer]: "ગ્રાહક કાઢી નાખો",
  [LangKeys.delete_supplier]: "સપ્લાયર કાઢી નાખો",
  [LangKeys.delete_customer_desc]: "શું તમે આ ગ્રાહકને કાઢી નાખવા માંગો છો? સંબંધિત તમામ ડેટા કાઢી નાખવામાં આવશે.",
  [LangKeys.delete_supplier_desc]: "શું તમે આ સપ્લાયરને કાઢી નાખવા માંગો છો? સંબંધિત તમામ ડેટા કાઢી નાખવામાં આવશે.",
  [LangKeys.add_gstin]: "GSTIN ઉમેરો",

  // SMS SETTINGS
  [LangKeys.sms_settings]: "SMS સેટિંગ્સ",
  [LangKeys.sms_settings_desc]: "આ ગ્રાહક માટે મેસેજ સેટિંગ્સ મેનેજ કરો",
  [LangKeys.edit_customer_details]: "ગ્રાહક વિગતો સંપાદિત કરો",
  [LangKeys.edit_customer_details_desc]: "તમે અહીં નામ, મોબાઇલ, સરનામું અને GST માહિતી બદલી શકો છો.",

  // PROFILE STRENGTH
  [LangKeys.weak]: "નબળું",
  [LangKeys.average]: "સરેરાશ",
  [LangKeys.good]: "સારું",
  [LangKeys.strong]: "મજબૂત",

  // STAFF & PERMISSIONS
  [LangKeys.save_staff]: "સ્ટાફ સાચવો",
  [LangKeys.update_staff]: "સ્ટાફ અપડેટ કરો",
  [LangKeys.cancel]: "રદ કરો",
  [LangKeys.no_staff_found]: "કોઈ સ્ટાફ મળ્યો નથી",
  [LangKeys.active]: "સક્રિય",
  [LangKeys.stopped]: "બંધ",
  [LangKeys.start]: "શરૂ કરો",
  [LangKeys.stop]: "બંધ કરો",
  [LangKeys.view]: "જુઓ",
  [LangKeys.add]: "ઉમેરો",
  [LangKeys.delete]: "કાઢી નાખો",
  [LangKeys.mobile_number]: "મોબાઇલ નંબર",
  [LangKeys.add_staff_title]: "સ્ટાફ ઉમેરો",
  [LangKeys.edit_staff_title]: "સ્ટાફમાં ફેરફાર કરો",
  [LangKeys.staff_deleted_success]: "સ્ટાફ સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો",
  [LangKeys.yes]: "હા",
  [LangKeys.no]: "ના",
  [LangKeys.khatabook_deleted_success]: "ખાતાબુક સફળતાપૂર્વક કાઢી નાખવામાં આવી",
  [LangKeys.something_went_wrong]: "કંઈક ખોટું થયું",
  [LangKeys.business_logo]: "વ્યવસાયનો લોગો",
  [LangKeys.choose_photo]: "ફોટો પસંદ કરો",
  [LangKeys.save_logo]: "લોગો સાચવો",
  [LangKeys.upload_error]: "અપલોડ ભૂલ",
  [LangKeys.upload_type_err]: "અપલોડ પ્રકાર ભૂલ",
  [LangKeys.enter_name]: "નામ દાખલ કરો",
  [LangKeys.enter_mobile]: "મોબાઇલ દાખલ કરો",
  [LangKeys.enter_business]: "વ્યવસાય દાખલ કરો",
  [LangKeys.enter_address]: "સરનામું દાખલ કરો",
  [LangKeys.gstin_details]: "GSTIN વિગતો",
  [LangKeys.gstin_number]: "GSTIN નંબર",
  [LangKeys.enter_gstin]: "GSTIN દાખલ કરો",
  [LangKeys.gstin_note]: "તમારો GSTIN તમારા વ્યવસાયની ચકાસણી કરવા અને ઇન્વૉઇસ બનાવવા માટે વપરાય છે.",
  [LangKeys.save_gstin]: "GSTIN સાચવો",
  [LangKeys.bank_details]: "બેંક વિગતો",
  [LangKeys.bank_name]: "બેંકનું નામ",
  [LangKeys.enter_bank_name]: "બેંકનું નામ દાખલ કરો",
  [LangKeys.account_number]: "ખાતા નંબર",
  [LangKeys.enter_account_no]: "ખાતા નંબર દાખલ કરો",
  [LangKeys.ifsc_code]: "IFSC કોડ",
  [LangKeys.enter_ifsc]: "IFSC કોડ દાખલ કરો",
  [LangKeys.bank_note]: "તમારું બેંક ખાતું ચુકવણીઓ મેળવવા માટે વપરાય છે.",
  [LangKeys.save_bank_details]: "બેંક વિગતો સાચવો",
  [LangKeys.invalid_bank_details]: "અમાન્ય બેંક વિગતો",
  [LangKeys.confirm]: "પુષ્ટિ કરો",
  [LangKeys.invalid_gstin]: "અમાન્ય GSTIN",
  [LangKeys.failed_to_save]: "સાચવવામાં નિષ્ફળ",

  // Cashbook
  [LangKeys.cash]: "રોકડ",
  [LangKeys.online]: "ઓનલાઇન",
  [LangKeys.total_balance_cashbook]: "કુલ બાકી રકમ",
  [LangKeys.today_balance]: "આજની સિલક",
  [LangKeys.view_report]: "રિપોર્ટ જુઓ",
  [LangKeys.out_entry]: "આવક",
  [LangKeys.in_entry]: "જાવક",
  [LangKeys.add_first_entry]: "તમારી પ્રથમ એન્ટ્રી ઉમેરો",
  [LangKeys.attach_bill]: "બિલ જોડો",
  [LangKeys.enter_amount]: "રકમ દાખલ કરો",
  [LangKeys.empty_title]: "હજુ સુધી કોઈ એન્ટ્રી નથી",
  [LangKeys.saving]: "સાચવી રહ્યું છે...",
  [LangKeys.save_failed]: "સાચવવામાં નિષ્ફળ",
  [LangKeys.server_error]: "સર્વર ભૂલ",
  [LangKeys.ok]: "ઓકે",
  [LangKeys.error]: "ભૂલ",
  [LangKeys.payment_mode]: "ચુકવણી મોડ",
  [LangKeys.entry_saved_offline_and_will_be_synced_later]: "એન્ટ્રી ઑફલાઇન સેવ થઈ ગઈ છે. ઇન્ટરનેટ મળતાં જ સિંક થઈ જશે",
  [LangKeys.entry_waiting_to_be_synced]: "એન્ટ્રી ઑફલાઇન સેવ છે, સિંક બાકી છે",
  [LangKeys.cash_in]: "જમા કરવામાં આવ્યું",
  [LangKeys.cash_out]: "નિકાસ કરવામાં આવી",
  [LangKeys.cashbook_status]: "કેશબુક સ્થિતિ",
  [LangKeys.real_time_cash_online]: "રીઅલ-ટાઇમ રોકડ અને ઓનલાઇન",

  // Cashbook Specific
  [LangKeys.entry_is_backed_up]: "એન્ટ્રીનો બેકઅપ લેવામાં આવ્યો છે",
  [LangKeys.safe_and_secure]: "100% સલામત અને સુરક્ષિત",
  [LangKeys.invalid_image_format_cashbook_popup]: "અસમર્થિત ફોર્મેટ. કૃપા કરીને JPG, PNG, અથવા WEBP નો ઉપયોગ કરો.",
  [LangKeys.photo_size_error_cashbook_popup]: "ફાઇલ ખૂબ મોટી છે (મહત્તમ 4MB)",
  [LangKeys.selected_image]: "પસંદ કરેલ",

  // Cashbook Report Screen
  [LangKeys.cashbook_report_title]: "કેશબુક રિપોર્ટ",
  [LangKeys.date_range]: "તારીખ શ્રેણી",
  [LangKeys.single_day]: "એક દિવસ",
  [LangKeys.this_week]: "આ અઠવાડિયે",
  [LangKeys.this_month]: "આ મહિને",
  [LangKeys.last_week]: "ગયા અઠવાડિયે",
  [LangKeys.last_month]: "ગયા મહિને",
  [LangKeys.all]: "બધા",
  [LangKeys.to]: "થી",
  [LangKeys.no_entries_found_period]: "આ સમયગાળામાં કોઈ એન્ટ્રીઓ મળી નથી.",
  [LangKeys.daily_balance_short]: "દૈનિક સિલક",
  [LangKeys.download_pdf]: "PDF ડાઉનલોડ કરો",
  [LangKeys.pdf_download_not_implemented]: "PDF ડાઉનલોડ હજુ સુધી લાગુ કરવામાં આવ્યું નથી.",

  // Cashbook Report Day Screen
  [LangKeys.daily_details]: "દૈનિક વિગતો",
  [LangKeys.no_entries_on_this_day]: "આ દિવસે કોઈ એન્ટ્રી નથી",
  [LangKeys.add_entries_help]: "તેમને અહીં જોવા માટે એન્ટ્રીઓ ઉમેરો.",
  [LangKeys.add_entry_to]: "એન્ટ્રી ઉમેરો",
  [LangKeys.add_entry]: "એન્ટ્રી ઉમેરો",
  [LangKeys.could_not_load_report]: "રિપોર્ટ લોડ કરી શકાયો નથી.",

  // Entry Details Screen
  [LangKeys.delete_failed]: "કાઢી નાખવામાં નિષ્ફળ",
  [LangKeys.photo_max_4mb]: "ફોટો (મહત્તમ 4MB)",
  [LangKeys.entry_of_amount]: "રકમની એન્ટ્રી ",

  // PDF CASHBOOK REPORT
  [LangKeys.daily_summary]: "દૈનિક સારાંશ",
  [LangKeys.total_in]: "કુલ આવક",
  [LangKeys.total_out]: "કુલ જાવક",
  [LangKeys.no_data_available]: "કોઈ ડેટા ઉપલબ્ધ નથી",

  // Months
  [LangKeys.month_1]: "જાન્યુ",
  [LangKeys.month_2]: "ફેબ્રુ",
  [LangKeys.month_3]: "માર્ચ",
  [LangKeys.month_4]: "એપ્રિલ",
  [LangKeys.month_5]: "મે",
  [LangKeys.month_6]: "જૂન",
  [LangKeys.month_7]: "જુલાઈ",
  [LangKeys.month_8]: "ઑગ",
  [LangKeys.month_9]: "સપ્ટે",
  [LangKeys.month_10]: "ઑક્ટો",
  [LangKeys.month_11]: "નવે",
  [LangKeys.month_12]: "ડિસે",

  // Customer Supplier Add
  [LangKeys.add_customer]: "ગ્રાહક ઉમેરો",
  [LangKeys.customer_already_exists]: "ગ્રાહક પહેલાથી જ ઉપલબ્ધ છે",
  [LangKeys.supplier_already_exists]: "સપ્લાયર પહેલાથી જ ઉપલબ્ધ છે",

  // Cashbook Empty State
  [LangKeys.cashbook_welcome]: "નમસ્તે! ચાલો આજની એન્ટ્રીઓ બનાવીએ",
  [LangKeys.add_first_entry_btn]: "તમારી પ્રથમ એન્ટ્રી ઉમેરો",
  [LangKeys.add_customers_collect_faster]: "ગ્રાહકો ઉમેરો અને ઝડપથી ચુકવણીઓ એકત્રિત કરો",

  // Permissions
  [LangKeys.permission_denied_title]: "પરવાનગી નામંજૂર",
  [LangKeys.permission_denied_content]: "ફોટો ઍક્સેસ કાયમી રીતે નામંજૂર છે. કૃપા કરીને ઍપ સેટિંગ્સમાં જઈને તેને સક્રિય કરો.",
  [LangKeys.permission_denied_settings_button]: "સેટિંગ્સ ખોલો",
  [LangKeys.permission_denied_cancel_button]: "રદ કરો",
  [LangKeys.permission_denied_generic_message]: "પરવાનગી નામંજૂર છે. ફોટો પસંદ કરવા માટે કૃપા કરીને ફોટો ઍક્સેસને મંજૂરી આપો.",

  // Contact Picker
  [LangKeys.permission_required]: "પરમિશન જરૂરી છે",
  [LangKeys.contacts_permission_message]: "સંપર્ક પસંદ કરવા માટે Contacts પરમિશન જરૂરી છે. કૃપા કરીને એપ સેટિંગ્સમાં તેને ચાલુ કરો.",
  [LangKeys.failed_to_open_contacts_picker]: "Contacts picker ખોલવામાં નિષ્ફળતા.",
  [LangKeys.permission_denied_to_read_contacts]: "Contacts વાંચવાની પરમિશન નકારી દેવામાં આવી છે.",

  // ADD ITEM SCREEN
  [LangKeys.tax_exempted]: "કર મુક્ત",
  [LangKeys.no_gst]: "GST લાગુ નથી",
  [LangKeys.select_photo]: "ફોટો પસંદ કરો",
  [LangKeys.gallery]: "ગેલેરી",
  [LangKeys.camera]: "કેમેરા",
  [LangKeys.please_enter_item_name]: "કૃપા કરીને આઇટમનું નામ દાખલ કરો",
  [LangKeys.failed_to_upload_image]: "ઇમેજ અપલોડ કરવામાં નિષ્ફળ",
  [LangKeys.item_updated_successfully]: "આઇટમ સફળતાપૂર્વક અપડેટ થઈ ગઈ",
  [LangKeys.item_saved_successfully]: "આઇટમ સફળતાપૂર્વક સેવ થઈ ગઈ",
  [LangKeys.failed_to_update_item]: "આઇટમ અપડેટ કરવામાં નિષ્ફળ",
  [LangKeys.failed_to_save_item]: "આઇટમ સેવ કરવામાં નિષ્ફળ",
  [LangKeys.confirm_deletion]: "ડિલીટની પુષ્ટિ",
  [LangKeys.are_you_sure_delete_item]: "શું તમે આ આઇટમ ડિલીટ કરવા માંગો છો?",
  [LangKeys.item_deleted_successfully]: "આઇટમ સફળતાપૂર્વક ડિલીટ થઈ ગઈ",
  [LangKeys.failed_to_delete_item]: "આઇટમ ડિલીટ કરવામાં નિષ્ફળ",
  [LangKeys.edit_item]: "આઇટમ એડિટ કરો",
  [LangKeys.edit_service]: "સેવા એડિટ કરો",
  [LangKeys.add_product]: "પ્રોડક્ટ ઉમેરો",
  [LangKeys.add_service]: "સેવા ઉમેરો",
  [LangKeys.add_hsn_and_gst_details]: "HSN અને GST વિગતો ઉમેરો",
  [LangKeys.hsn]: "HSN",
  [LangKeys.enter_hsn]: "HSN દાખલ કરો",
  [LangKeys.gst_rate_percent]: "GST દર (%)",
  [LangKeys.enter_gst_rate]: "GST દર દાખલ કરો",
  [LangKeys.primary_unit]: "મુખ્ય એકમ",
  [LangKeys.enter_item_name_here]: "અહીં આઇટમનું નામ લખો",
  [LangKeys.sale_price]: "વેચાણ કિંમત",
  [LangKeys.purchase_price]: "ખરીદી કિંમત",
  [LangKeys.tax_included]: "કરમાં સમાવેશ છે",
  [LangKeys.opening_stock]: "શરૂઆતનો સ્ટોક",
  [LangKeys.low_stock_alert]: "ઓછા સ્ટોકની સૂચના",
  [LangKeys.as_of_date]: "તારીખ મુજબ",
  [LangKeys.enter_price]: "કિંમત દાખલ કરો",
  [LangKeys.enter_count]: "માત્રા દાખલ કરો",
  [LangKeys.save_item]: "આઇટમ સેવ કરો",
  [LangKeys.delete_item]: "આઇટમ ડિલીટ કરો",
  [LangKeys.select_unit]: "એકમ પસંદ કરો",
  [LangKeys.search_unit]: "એકમ શોધો",
  [LangKeys.add_gst_rate]: "GST દર ઉમેરો",
  [LangKeys.add_custom_tax]: "કસ્ટમ કર ઉમેરો",
  [LangKeys.custom_tax]: "કસ્ટમ કર",
  [LangKeys.gst]: "GST",
  [LangKeys.cess]: "સેસ",
  [LangKeys.add_hsn_code]: "HSN કોડ ઉમેરો",
  [LangKeys.hsn_code]: "HSN કોડ",
  [LangKeys.item_name]: "આઇટમનું નામ",
  [LangKeys.enter_hsn_code]: "HSN કોડ દાખલ કરો",
  [LangKeys.enter_item_name]: "આઇટમનું નામ દાખલ કરો",
  [LangKeys.results]: "પરિણામો",
  [LangKeys.no_hsn_code_found]: "કોઈ HSN કોડ મળ્યો નથી",
  [LangKeys.use]: "ઉપયોગ કરો",
  [LangKeys.as_hsn_code]: "HSN કોડ તરીકે",
  [LangKeys.you_are_offline_please_connect_to_the_internet]: "તમે ઓફલાઇન છો. કૃપા કરીને ઇન્ટરનેટ સાથે કનેક્ટ કરો.",

  // ITEMS SCREEN
  [LangKeys.products]: "પ્રોડક્ટ્સ",
  [LangKeys.services]: "સેવાઓ",
  [LangKeys.add_product_caps]: "પ્રોડક્ટ ઉમેરો",
  [LangKeys.add_service_caps]: "સેવા ઉમેરો",
  [LangKeys.add_items_and_get_started]: "તમારી ઇન્વેન્ટરી મેનેજમેન્ટ શરૂ કરો",
  [LangKeys.manage_stock_feature]: "તમારા વ્યવસાય માટે સ્માર્ટ સ્ટોક નિયંત્રણ",
  [LangKeys.detailed_stock_history_feature]: "આઇટમ પ્રવૃત્તિનો સંપૂર્ણ રેકોર્ડ જુઓ",
  [LangKeys.track_prices_and_profits_feature]: "કિંમત અને નફા માર્જિનને સરળતાથી મોનીટર કરો",

  [LangKeys.search_items]: "આઇટમ શોધો",
  [LangKeys.my_items]: "મારા આઇટમ",
  [LangKeys.item_added]: "આઇટમ ઉમેરાઈ",
  [LangKeys.low_stock]: "ઓછો સ્ટોક",
  [LangKeys.current_stock]: "વર્તમાન સ્ટોક",
  [LangKeys.stock_history]: "સ્ટોક ઇતિહાસ",
  [LangKeys.stock_in]: "સ્ટોક ઇન",
  [LangKeys.stock_out]: "સ્ટોક આઉટ",
  [LangKeys.add_services_and_get_started]: "તમારી સેવાઓનું મેનેજમેન્ટ શરૂ કરો",
  [LangKeys.manage_services_feature]: "તમારી બધી સેવા ઓફરિંગ્સને ગોઠવો અને મેનેજ કરો",
  [LangKeys.save_sac_and_gst_feature]: "SAC કોડ અને GST વિગતો સરળતાથી સેવ કરો",
  [LangKeys.track_sales_and_bills_feature]: "સેવા વેચાણ અને બિલિંગ રેકોર્ડ ટ્રેક કરો",

  [LangKeys.net_monthly_sales]: "કુલ માસિક વેચાણ",
  [LangKeys.rupees]: "રૂપીયા",
  [LangKeys.search_services]: "સેવાઓ શોધો",
  [LangKeys.my_services]: "મારી સેવાઓ",
  [LangKeys.service_price]: "સેવાની કિંમત",
  [LangKeys.unit]: "એકમ",
  [LangKeys.enter_purchased_quantity]: "ખરીદેલી માત્રા દાખલ કરો",
  [LangKeys.enter_sold_quantity]: "વેચેલી માત્રા દાખલ કરો",
  [LangKeys.quantity]: "માત્રા",
  [LangKeys.add_notes_optional]: "નોટ્સ ઉમેરો (વૈકલ્પિક)",
  [LangKeys.stock_in_caps]: "સ્ટોક ઇન",
  [LangKeys.stock_out_caps]: "સ્ટોક આઉટ",
  [LangKeys.total_stock]: "કુલ સ્ટોક",
  [LangKeys.low_stock_items]: "ઓછા સ્ટોકવાળી વસ્તુઓ",
  [LangKeys.all_items]: "બધી વસ્તુઓ",
  [LangKeys.failed_to_load_items]: "આઇટમ્સ લોડ કરવામાં નિષ્ફળ",


  // ================= ITEMS SALES REPORT SCREEN =================

  [LangKeys.item_sales_report]: "વસ્તુ વેચાણ અહેવાલ",
  [LangKeys.total_qty_sold]: "કુલ વેચાયેલી માત્રા",
  [LangKeys.units]: "એકમ",
  [LangKeys.nos]: "નંગ",
  [LangKeys.sold]: "વેચ્યું",
  [LangKeys.bought]: "ખરીદ્યું",
  [LangKeys.profit]: "નફો",
  [LangKeys.loss]: "નુકસાન",

  // Filter & Sort
  [LangKeys.filter_by_stock]: "સ્ટોક મુજબ ફિલ્ટર કરો",
  [LangKeys.sort_by_name_az]: "નામ (A–Z) મુજબ",
  [LangKeys.sort_by_name_za]: "નામ (Z–A) મુજબ",

  // ADD SERVICE SCREEN
  [LangKeys.failed_to_process_image]: "ઇમેજ પ્રોસેસ કરવામાં નિષ્ફળ",
  [LangKeys.could_not_pick_image]: "ઇમેજ પસંદ કરી શકાઈ નથી",
  [LangKeys.failed_to_upload_photo]: "ફોટો અપલોડ કરવામાં નિષ્ફળ",
  [LangKeys.failed_to_update_service]: "સેવા અપડેટ કરવામાં નિષ્ફળ",
  [LangKeys.failed_to_add_service]: "સેવા ઉમેરવામાં નિષ્ફળ",
  [LangKeys.are_you_sure_delete_service]: "શું તમે આ સેવા ડિલીટ કરવા માંગો છો?",
  [LangKeys.failed_to_delete_service]: "સેવા ડિલીટ કરવામાં નિષ્ફળ",
  [LangKeys.add_sac_and_gst_details]: "SAC અને GST વિગતો ઉમેરો",
  [LangKeys.sac_code]: "SAC કોડ",
  [LangKeys.enter_sac]: "SAC દાખલ કરો",
  [LangKeys.enter_service_name_here]: "અહીં સેવાનું નામ લખો",
  [LangKeys.please_enter_service_name]: "કૃપા કરીને સેવાનું નામ દાખલ કરો",
  [LangKeys.tax_included_in_price]: "કિંમતમાં કર સમાવેશ છે",
  [LangKeys.delete_service]: "સેવા ડિલીટ કરો",
  [LangKeys.save_changes]: "ફેરફારો સેવ કરો",

  // ITEM DETAILS SCREEN
  [LangKeys.edit_product]: "પ્રોડક્ટ એડિટ કરો",
  [LangKeys.stock_quantity]: "સ્ટોક માત્રા",
  [LangKeys.stock_value]: "સ્ટોક કિંમત",

  // SERVICE DETAILS SCREEN
  [LangKeys.edit_service_caps]: "સેવા એડિટ કરો",
  [LangKeys.service_name]: "સેવાનું નામ",
  [LangKeys.gst_percent]: "GST %",
  [LangKeys.no_sales_added_for_service]: "આ સેવા માટે કોઈ વેચાણ ઉમેરાયેલ નથી",
  [LangKeys.zero_percent]: "0%",

  // BILLS SCREEN
  [LangKeys.bills_add_sale]: "વેચાણ ઉમેરો",
  [LangKeys.bills_search_sales_hint]: "વેચાણ શોધો",
  [LangKeys.bills_add_purchase]: "ખરીદી ઉમેરો",
  [LangKeys.bills_search_purchases_hint]: "ખરીદી શોધો",
  [LangKeys.bills_add_expense]: "ખર્ચ ઉમેરો",
  [LangKeys.bills_search_expenses_hint]: "ખર્ચ શોધો",
  [LangKeys.bills_start_creating_gst]: "તાત્કાલિક GST બિલ બનાવવાનું શરૂ કરો",
  [LangKeys.bills_tab_sale]: "વેચાણ",
  [LangKeys.bills_tab_purchase]: "ખરીદી",
  [LangKeys.bills_tab_expense]: "ખર્ચ",
  [LangKeys.bills_monthly_sales]: "માસિક વેચાણ",
  [LangKeys.bills_monthly_purchases]: "માસિક ખરીદી",
  [LangKeys.bills_view_reports]: "રિપોર્ટ જુઓ",
  [LangKeys.bills_todays_in]: "આજની આવક",
  [LangKeys.bills_todays_out]: "આજનો ખર્ચ",
  [LangKeys.bills_cashbook]: "કેશબુક",
  [LangKeys.bills_empty_state_title]: "પ્રોફેશનલ ઇનવોઇસ તરત બનાવો",
  [LangKeys.bills_empty_state_subtitle]: "લેજર, સ્ટોક અને કેશબુક આપમેળે અપડેટ થાય છે",
  [LangKeys.bills_empty_state_gst_support]: "GST અને Non-GST બંને બિલિંગ સપોર્ટ",
  [LangKeys.bills_see_sample_invoices]: "સેમ્પલ ઇનવોઇસ જુઓ",
  [LangKeys.bills_no_matching_found]: "કોઈ મેળ ખાતું બિલ મળ્યું નથી",
  [LangKeys.bills_payment_in]: "પ્રાપ્ત ચુકવણી",
  [LangKeys.bills_status_fully_paid]: "સંપૂર્ણ ચૂકવેલ",
  [LangKeys.bills_status_unpaid]: "બાકી",
  [LangKeys.bills_sale_bill]: "વેચાણ બિલ",
  [LangKeys.bills_purchase_bill]: "ખરીદી બિલ",
  [LangKeys.bills_expense_bill]: "ખર્ચ",
  [LangKeys.bills_more_button]: "વધુ",
  [LangKeys.bills_added_to_ledger]: "✓ ખાતામાં ઉમેરાયું",

  // FILTER & SORT
  [LangKeys.filter_and_sort]: "ફિલ્ટર અને સૉર્ટ",
  [LangKeys.filter_by_status]: "સ્થિતિ મુજબ ફિલ્ટર કરો",
  [LangKeys.filter_all_bills]: "બધા બિલ",
  [LangKeys.filter_paid_bills]: "ચુકવાયેલા બિલ",
  [LangKeys.filter_unpaid_bills]: "બાકી બિલ",
  [LangKeys.sort_by]: "ક્રમબદ્ધ કરો",
  [LangKeys.sort_latest_first]: "નવીનતમ પહેલા",
  [LangKeys.sort_oldest_first]: "જૂના પહેલા",
  [LangKeys.sort_highest_amount]: "ઉચ્ચતમ રકમ",
  [LangKeys.sort_lowest_amount]: "ન્યૂનતમ રકમ",
  [LangKeys.clear_filters]: "ફિલ્ટર સાફ કરો",
  [LangKeys.apply_filters]: "ફિલ્ટર લાગુ કરો",

  // ADD BILL SCREEN
  [LangKeys.add_bill_sale]: "વેચાણ",
  [LangKeys.add_bill_purchase]: "ખરીદી",
  [LangKeys.add_bill_expense]: "ખર્ચ",
  [LangKeys.add_bill_edit_sale_gst_bill]: "વેચાણ GST બિલ સંપાદિત કરો",
  [LangKeys.add_bill_sale_gst_bill]: "વેચાણ GST બિલ",
  [LangKeys.add_bill_edit_purchase_gst_bill]: "ખરીદી GST બિલ સંપાદિત કરો",
  [LangKeys.add_bill_purchase_gst_bill]: "ખરીદી GST બિલ",
  [LangKeys.add_bill_edit_expense]: "ખર્ચ સંપાદિત કરો",
  [LangKeys.add_bill_expense_title]: "ખર્ચ",
  [LangKeys.add_bill_edit_sale_bill]: "વેચાણ બિલ સંપાદિત કરો",
  [LangKeys.add_bill_sale_bill]: "વેચાણ બિલ",
  [LangKeys.add_bill_edit_purchase_bill]: "ખરીદી બિલ સંપાદિત કરો",
  [LangKeys.add_bill_purchase_bill]: "ખરીદી બિલ",
  [LangKeys.add_bill_sale_bill_no]: "વેચાણ બિલ નં.",
  [LangKeys.add_bill_purchase_bill_no]: "ખરીદી બિલ નં.",
  [LangKeys.add_bill_expense_no]: "ખર્ચ નં.",
  [LangKeys.add_bill_update_sale_bill]: "વેચાણ બિલ અપડેટ કરો",
  [LangKeys.add_bill_generate_sale_bill]: "વેચાણ બિલ બનાવો",
  [LangKeys.add_bill_update_purchase_bill]: "ખરીદી બિલ અપડેટ કરો",
  [LangKeys.add_bill_generate_purchase_bill]: "ખરીદી બિલ બનાવો",
  [LangKeys.add_bill_update_expense]: "ખર્ચ અપડેટ કરો",
  [LangKeys.add_bill_generate_expense]: "ખર્ચ ઉમેરો",
  [LangKeys.add_bill_select_customer_error]: "કૃપા કરીને ગ્રાહક પસંદ કરો",
  [LangKeys.add_bill_add_item_error]: "ઓછામાં ઓછું એક આઇટમ ઉમેરો",
  [LangKeys.add_bill_updated_successfully]: "સફળતાપૂર્વક અપડેટ થયું",
  [LangKeys.add_bill_saved_successfully]: "સફળતાપૂર્વક સેવ થયું",
  [LangKeys.add_bill_failed_to_save]: "બિલ સેવ થઈ શક્યું નથી",
  [LangKeys.add_bill_error_occurred]: "કંઈક ખોટું થયું",
  [LangKeys.add_bill_bill_to]: "બિલ પ્રાપ્તકર્તા",
  [LangKeys.add_bill_search_parties]: "પાર્ટી શોધો",
  [LangKeys.add_bill_add_new_party]: "નવી પાર્ટી ઉમેરો",
  [LangKeys.add_bill_edit_party_details]: "પાર્ટી વિગતો સંપાદિત કરો",
  [LangKeys.add_bill_items]: "આઇટમ્સ",
  [LangKeys.add_bill_enter_items_from_inventory]: "ઇન્વેન્ટરીમાંથી આઇટમ ઉમેરો",
  [LangKeys.add_bill_add_new_item]: "નવી આઇટમ ઉમેરો",
  [LangKeys.add_bill_n_items]: "{n} આઇટમ્સ",
  [LangKeys.add_bill_edit_or_add_items]: "આઇટમ સંપાદિત કરો અથવા ઉમેરો",
  [LangKeys.add_bill_discount]: "ડિસ્કાઉન્ટ",
  [LangKeys.add_bill_extra_discount]: "વધારાની છૂટ",
  [LangKeys.add_bill_item_subtotal]: "આઇટમ ઉપકુલ",
  [LangKeys.add_bill_round_off]: "રાઉન્ડ ઓફ",
  [LangKeys.add_bill_bill_amount]: "બિલ રકમ",
  [LangKeys.add_bill_optional_fields]: "વૈકલ્પિક વિગતો",
  [LangKeys.add_bill_printed_on_invoice]: "ઇનવોઇસ પર પ્રિન્ટ થશે",
  [LangKeys.add_bill_custom_fields]: "કસ્ટમ ફીલ્ડ્સ",
  [LangKeys.add_bill_party_address]: "પાર્ટીનું સરનામું",
  [LangKeys.add_bill_your_address]: "તમારું સરનામું",
  [LangKeys.add_bill_terms_conditions]: "નિયમો અને શરતો",
  [LangKeys.add_bill_private_to_you]: "માત્ર તમારા માટે",
  [LangKeys.add_bill_add_notes_photos]: "નોટ્સ અથવા ફોટા ઉમેરો",
  [LangKeys.add_bill_n_photos_added]: "{n} ફોટા ઉમેરાયા",
  [LangKeys.add_bill_balance_due]: "બાકી રકમ",
  [LangKeys.cgst]: "CGST",
  [LangKeys.sgst]: "SGST",
  [LangKeys.pending_bill_no]: "બાકી બિલ નં.",
  [LangKeys.add_bill_add_due_to_ledger]: "લેજરમાં બાકી બેલેન્સ ઉમેરો",
  [LangKeys.add_bill_select_supplier_error]: "કૃપા કરીને સપ્લાયર પસંદ કરો",

  // BILL DETAILS SCREEN
  [LangKeys.bill_details_error_id_missing]: "બિલ ID મળતી નથી",
  [LangKeys.bill_details_failed_to_load]: "બિલ લોડ થઈ શક્યું નથી",
  [LangKeys.bill_details_delete_confirmation_title]: "બિલ કાઢી નાખો",
  [LangKeys.bill_details_delete_button]: "કાઢી નાખો",
  [LangKeys.bill_details_delete_confirmation_content]: "શું તમે ખરેખર આ બિલ કાઢી નાખવા માંગો છો? કૃપા કરીને ધ્યાન રાખો કે બિલ સાથે જોડાયેલી કેશબુક એન્ટ્રી પણ કાઢી નાખવામાં આવશે.",
  [LangKeys.bill_details_deleted_successfully]: "બિલ સફળતાપૂર્વક કાઢી નાખવામાં આવ્યું",
  [LangKeys.bill_details_failed_to_delete]: "બિલ કાઢી શક્યું નથી",
  [LangKeys.bill_details_generating_pdf]: "PDF બનાવી રહ્યા છીએ",
  [LangKeys.bill_details_share_text]: "આ રહ્યું તમારું બિલ",
  [LangKeys.bill_details_failed_to_share]: "બિલ શેર થઈ શક્યું નથી",
  [LangKeys.bill_details_title]: "બિલ વિગતો",
  [LangKeys.bill_details_could_not_load]: "બિલ વિગતો લોડ થઈ શકી નથી",
  [LangKeys.bill_details_status]: "સ્થિતિ",
  [LangKeys.bill_details_status_pending]: "બાકી",
  [LangKeys.bill_details_no_items]: "કોઈ આઇટમ ઉમેરેલ નથી",
  [LangKeys.bill_details_view_pdf]: "PDF જુઓ",

  // EXPENSE DETAILS SCREEN
  [LangKeys.expense_number_prefix]: "ખર્ચ #",
  [LangKeys.edit_expense]: "ખર્ચ સંપાદિત કરો",
  [LangKeys.delete_expense]: "ખર્ચ કાઢી નાખો",
  [LangKeys.deleting_expense]: "કાઢી રહ્યા છીએ...",
  [LangKeys.expense_deleted_successfully]: "ખર્ચ સફળતાપૂર્વક કાઢી નાખ્યો",
  [LangKeys.failed_to_delete_expense]: "ખર્ચ કાઢવામાં નિષ્ફળ",
  [LangKeys.edit_feature_coming_soon]: "સંપાદન સુવિધા જલ્દી આવી રહી છે!",
  [LangKeys.delete_expense_confirmation]: "શું તમે ખરેખર આ ખર્ચ કાઢી નાખવા માંગો છો?",

  // INVOICE PREVIEW SCREEN
  [LangKeys.invoice_preview_title]: "ઇનવોઇસ પૂર્વદર્શન",
  [LangKeys.invoice_preview_generating]: "ઇનવોઇસ બનાવી રહ્યા છીએ",
  [LangKeys.invoice_preview_failed]: "ઇનવોઇસ બનાવી શક્યા નથી",
  [LangKeys.invoice_preview_preparing_print]: "પ્રિન્ટ માટે તૈયારી",
  [LangKeys.invoice_preview_failed_print]: "પ્રિન્ટ થઈ શક્યું નથી",
  [LangKeys.invoice_preview_delete_title]: "ઇનવોઇસ કાઢી નાખો",
  [LangKeys.invoice_preview_delete_content]: "શું તમે આ ઇન્વૉઇસ કાઢી નાખવા માંગો છો? કૃપા કરીને નોંધ લો કે સંબંધિત કેશબુક એન્ટ્રી પણ કાઢી નાખવામાં આવશે.",
  [LangKeys.invoice_preview_deleted_successfully]: "ઇનવોઇસ સફળતાપૂર્વક કાઢી નાખવામાં આવ્યું",
  [LangKeys.invoice_preview_failed_delete]: "ઇનવોઇસ કાઢી શક્યું નથી",
  [LangKeys.invoice_preview_theme_premium]: "પ્રીમિયમ",
  [LangKeys.invoice_preview_theme_thermal]: "થર્મલ",
  [LangKeys.invoice_preview_theme_basic]: "બેસિક",
  [LangKeys.invoice_preview_theme_new]: "નવું",
  [LangKeys.invoice_preview_download]: "ઇનવોઇસ ડાઉનલોડ કરો",
  [LangKeys.invoice_preview_share]: "ઇનવોઇસ શેર કરો",
  [LangKeys.invoice_preview_print]: "ઇનવોઇસ પ્રિન્ટ કરો",
  [LangKeys.invoice_preview_create_new]: "નવું બનાવો",
  [LangKeys.invoice_preview_done]: "પૂર્ણ",

  // PAYMENT DETAILS SCREEN
  [LangKeys.payment_details_title_in]: "પ્રાપ્ત ચુકવણી",
  [LangKeys.payment_details_title_out]: "આપેલ ચુકવણી",
  [LangKeys.payment_details_share_text]: "ચુકવણી વિગતો",
  [LangKeys.payment_details_failed_to_share]: "ચુકવણી વિગતો શેર થઈ શકી નથી",
  [LangKeys.payment_details_adjusted_invoices]: "સમાયોજિત ઇનવોઇસ",

  // SAMPLE INVOICES SCREEN
  [LangKeys.sample_invoice_title]: "નમૂના",
  [LangKeys.premium_invoice]: "પ્રીમિયમ ઇનવોઇસ",
  [LangKeys.thermal_invoice]: "થર્મલ ઇનવોઇસ",
  [LangKeys.basic_invoice]: "બેસિક ઇનવોઇસ",
  [LangKeys.use_this_template]: "આ ટેમ્પલેટ વાપરો",

  // ITEM SELECT SHEET
  [LangKeys.item_select_not_enough_stock]: "પર્યાપ્ત સ્ટોક નથી. માત્ર {availableStock} ઉપલબ્ધ છે.",
  [LangKeys.item_select_no_items_found]: "કોઈ આઇટમ મળ્યું નથી",
  [LangKeys.item_select_item_discount]: "આઇટમ ડિસ્કાઉન્ટ",
  [LangKeys.item_select_final_price]: "અંતિમ કિંમત",
  [LangKeys.item_select_gst_rate]: "GST દર",
  [LangKeys.item_select_item_single]: "આઇટમ",
  [LangKeys.item_select_item_plural]: "આઇટમ્સ",
  [LangKeys.item_select_continue]: "આગળ વધો",
  [LangKeys.item_select_add_items_to_invoice]: "ઇનવોઇસમાં આઇટમ ઉમેરો",
  [LangKeys.item_select_search_created_items]: "બનાવેલ આઇટમ શોધો",
  [LangKeys.item_select_add_new]: "નવું ઉમેરો",

  // QUICK ADD ITEM DIALOG
  [LangKeys.add_more_details]: "વધુ ઉમેરો (સ્ટોક, ખરીદી કિંમત વગેરે)",
  [LangKeys.add_item_to_bill]: "બિલમાં આઇટમ ઉમેરો",
  [LangKeys.please_enter_value]: "કૃપા કરીને કિંમત દાખલ કરો",
  [LangKeys.please_enter_valid_number]: "કૃપા કરીને માન્ય નંબર દાખલ કરો",

  // CUSTOM FIELDS DIALOG
  [LangKeys.add_bill_custom_fields_subtitle]: "મહત્તમ 5 કસ્ટમ ફીલ્ડ ઉમેરો (ઉદાહરણ- સીરિયલ નંબર, બેચ, IMEI વગેરે)",
  [LangKeys.add_bill_add_new_custom_field]: "નવું કસ્ટમ ફીલ્ડ ઉમેરો",
  [LangKeys.add_bill_max_custom_fields]: "તમે મહત્તમ 5 કસ્ટમ ફીલ્ડ જ ઉમેરવા શકો છો.",
  [LangKeys.add_bill_custom_field_name_hint]: "ફીલ્ડ નામ",
  [LangKeys.add_bill_custom_field_value_hint]: "મૂલ્ય",

  // EDIT PRICE DIALOG
  [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
  [LangKeys.edit_price_enter_discount_hint]: "ડિસ્કાઉન્ટ દાખલ કરો",
  [LangKeys.rupee]: "રૂપીયા",
  [LangKeys.percentage]: "ટકાવારી",
  [LangKeys.rate]: "દર",
  [LangKeys.tax]: "કર",

  // ADDRESS SCREEN
  [LangKeys.address_business_address_title]: "વ્યવસાયનું સરનામું",
  [LangKeys.address_flat_building_number]: "ફ્લેટ / બિલ્ડિંગ નંબર",
  [LangKeys.address_enter_flat_building_number]: "કૃપા કરીને ફ્લેટ/બિલ્ડિંગ નંબર દાખલ કરો",
  [LangKeys.address_area_locality]: "વિસ્તાર / લોકેલિટી",
  [LangKeys.address_enter_area_locality]: "કૃપા કરીને વિસ્તાર/લોકેલિટી દાખલ કરો",
  [LangKeys.address_city]: "શહેર",
  [LangKeys.address_enter_city]: "કૃપા કરીને શહેર દાખલ કરો",
  [LangKeys.address_state]: "રાજ્ય",
  [LangKeys.address_enter_state]: "કૃપા કરીને રાજ્ય દાખલ કરો",
  [LangKeys.address_pincode]: "પિનકોડ",
  [LangKeys.address_enter_pincode]: "કૃપા કરીને પિનકોડ દાખલ કરો",
  [LangKeys.address_invalid_pincode]: "અમાન્ય પિનકોડ",

  // PARTY ADDRESS SCREEN
  [LangKeys.party_address_title]: "ગ્રાહકનું સરનામું",
  [LangKeys.party_address_billing_address]: "બિલિંગ સરનામું",
  [LangKeys.party_address_shipping_same_as_billing]: "શિપિંગ સરનામું બિલિંગ જેવું જ છે",

  // ADD NOTES AND PHOTOS DIALOG
  [LangKeys.add_notes_and_photos_title]: "નોટ્સ અને ફોટા ઉમેરો",
  [LangKeys.add_notes_and_photos_subtitle]: "વધારાની વિગતો અથવા ચિત્રો ઉમેરો",
  [LangKeys.add_notes_and_photos_notes_hint]: "અહીં નોટ્સ લખો",
  [LangKeys.photos_access_permanently_denied]: "ફોટો ઍક્સેસ કાયમી રીતે નિષ્ક્રિય છે. કૃપા કરીને એપ સેટિંગ્સમાં જઈને સક્રિય કરો.",
  [LangKeys.photos_access_denied]: "ફોટો પસંદ કરવા માટે, કૃપા કરીને ડિવાઇસ સેટિંગ્સમાં કેમેરા અથવા ફોટોઝ માટે પરવાનગી આપો.",
  [LangKeys.open_settings]: "સેટિંગ્સ ખોલો",

  // TERMS AND CONDITIONS DIALOG
  [LangKeys.terms_and_conditions_title]: "નિયમો અને શરતો",
  [LangKeys.terms_and_conditions_hint]: "નિયમો અને શરતો દાખલ કરો",

  // KHATA TABS
  [LangKeys.customers]: "ગ્રાહકો",
  [LangKeys.suppliers]: "સપ્લાયરો",
  [LangKeys.search_supplier]: "સપ્લાયર શોધો",
  [LangKeys.add_first_customer]: "તમારો પહેલો ગ્રાહક ઉમેરો",
  [LangKeys.add_first_supplier]: "તમારો પહેલો સપ્લાયર ઉમેરો",
  [LangKeys.add_new_customer_prompt]: "હજુ સુધી કોઈ ગ્રાહક ઉમેરાયો નથી. નવો ગ્રાહક ઉમેરવા માટે ઉપર આપેલ “+” બટન પર ટૅપ કરો.",
  [LangKeys.add_new_suppliers_prompt]: "હજુ સુધી કોઈ સપ્લાયર ઉમેરાયો નથી. નવો સપ્લાયર ઉમેરવા માટે ઉપર આપેલ “+” બટન પર ટૅપ કરો.",

  // CASHBOOK HELP DIALOG
  [LangKeys.cashbook_help_title]: "કેશબુક મદદ",
  [LangKeys.cashbook_help_in_title]: "કેશ ઇન (જમા)",
  [LangKeys.cashbook_help_in_desc]: "અહીં તમારા વ્યવસાયમાં પ્રાપ્ત થયેલી તમામ રોકડ એન્ટ્રીઓનો રેકોર્ડ બતાવવામાં આવે છે.",
  [LangKeys.cashbook_help_out_title]: "કેશ આઉટ (નિકાસ)",
  [LangKeys.cashbook_help_out_desc]: "અહીં તમારા વ્યવસાયમાંથી ખર્ચાયેલી તમામ રોકડ એન્ટ્રીઓનો રેકોર્ડ બતાવવામાં આવે છે.",
  [LangKeys.cashbook_help_total_balance_title]: "કુલ બેલેન્સ",
  [LangKeys.cashbook_help_total_balance_desc]: "આ તમારા કેશબુકનો વર્તમાન કુલ બેલેન્સ દર્શાવે છે.",
  [LangKeys.cashbook_help_today_balance_title]: "આજનો બેલેન્સ",
  [LangKeys.cashbook_help_today_balance_desc]: "આ ફક્ત આજની રોકડ લેવડદેવડના આધાર પર બેલેન્સ દર્શાવે છે.",
  [LangKeys.cashbook_help_report_title]: "કેશબુક રિપોર્ટ",
  [LangKeys.cashbook_help_report_desc]: "અહીંથી તમે કેશબુક રિપોર્ટ જોઈ અને ડાઉનલોડ કરી શકો છો.",

  // ADD EXPENSE SCREEN
  [LangKeys.expense_amount]: "ખર્ચની રકમ",
  [LangKeys.select_category]: "શ્રેણી પસંદ કરો",
  [LangKeys.select_expense_category]: "ખર્ચની શ્રેણી પસંદ કરો",
  [LangKeys.expense_items_warning]: "ખર્ચની વસ્તુઓ તમારી ઇન્વેન્ટરી વસ્તુઓને અસર કરશે નહીં.",
  [LangKeys.add_expense_items_optional]: "ખર્ચની વસ્તુઓ ઉમેરો (વૈકલ્પિક)",
  [LangKeys.expense_items_feature_coming_soon]: "ખર્ચ વસ્તુ સુવિધા જલ્દી આવી રહી છે!",
  [LangKeys.notes_and_photos_optional]: "નોંધો અને ફોટા (વૈકલ્પિક)",
  [LangKeys.photos_added]: "ફોટા ઉમેરાયા",
  [LangKeys.save_expense_amount]: "ખર્ચ સેવ કરો",
  [LangKeys.update_expense_amount]: "ખર્ચ અપડેટ કરો",
  [LangKeys.expense_saved_successfully]: "ખર્ચ સફળતાપૂર્વક સેવ થયો",
  [LangKeys.expense_updated_successfully]: "ખર્ચ સફળતાપૂર્વક અપડેટ થયો",
  [LangKeys.failed_to_save_expense]: "ખર્ચ સેવ કરવામાં નિષ્ફળ",
  [LangKeys.enter_valid_amount]: "કૃપા કરીને માન્ય રકમ દાખલ કરો.",
  [LangKeys.please_select_expense_category]: "કૃપા કરીને ખર્ચની શ્રેણી પસંદ કરો.",
  [LangKeys.category]: "શ્રેણી",

  // EXPENSE CATEGORIES
  [LangKeys.cat_rent]: "ભાડું",
  [LangKeys.cat_salaries]: "પગાર / મજૂરી",
  [LangKeys.cat_electricity]: "વીજળી",
  [LangKeys.cat_water]: "પાણીનું બિલ",
  [LangKeys.cat_internet]: "ટેલિફોન / ઇન્ટરનેટ",
  [LangKeys.cat_office]: "ઓફિસ ખર્ચ",
  [LangKeys.cat_marketing]: "માર્કેટિંગ / જાહેરાત",
  [LangKeys.cat_travel]: "પ્રવાસ",
  [LangKeys.cat_fuel]: "ઇંધણ / પેટ્રોલ",
  [LangKeys.cat_food]: "ખોરાક / નાસ્તો",
  [LangKeys.cat_repairs]: "મરામત અને જાળવણી",
  [LangKeys.cat_election]: "ચૂંટણી ખર્ચ",
  [LangKeys.cat_taxes]: "કર / GST",
  [LangKeys.cat_insurance]: "વીમા",
  [LangKeys.cat_cleaning]: "સફાઈ",
  [LangKeys.cat_delivery]: "ડિલિવરી / શિપિંગ",
  [LangKeys.cat_software]: "સોફ્ટવેર / એપ્સ",
  [LangKeys.cat_furniture]: "ફર્નિચર",
  [LangKeys.cat_other]: "અન્ય",

  // EXPENSE EMPTY STATE
  [LangKeys.expense_empty_title]: "તમારા ખર્ચોને સરળતાથી મેનેજ કરો",
  [LangKeys.expense_empty_subtitle]: "તમારા વ્યવસાયના બધા ખર્ચ એક જ જગ્યાએ ટ્રેક કરો.",
  [LangKeys.expense_empty_footer]: "બધા ખર્ચો આપમેળે કેશબુકમાં ઉમેરાઈ જાય છે.",

  // BILL REPORT SCREEN
  [LangKeys.bill_report_title]: "બિલ રિપોર્ટ",
  [LangKeys.report_for_period]: "આ સમયગાળા માટેનો રિપોર્ટ",
  [LangKeys.select_date_range]: "તારીખનો સમયગાળો પસંદ કરો",
  [LangKeys.total_sales]: "કુલ વેચાણ",
  [LangKeys.total_purchases]: "કુલ ખરીદી",
  [LangKeys.total_expenses]: "કુલ ખર્ચ",
  [LangKeys.net_profit]: "શુદ્ધ નફો",
  [LangKeys.net_loss]: "શુદ્ધ નુકસાન",
  [LangKeys.all_transactions]: "બધી લેવડદેવડ",
  [LangKeys.no_transactions_found_period]: "આ સમયગાળામાં કોઈ લેવડદેવડ મળી નથી",
  [LangKeys.expense_fallback_category]: "અન્ય ખર્ચ",

  // SALES REPORT SCREEN
  [LangKeys.sales_report]: "વેચાણ રિપોર્ટ",
  [LangKeys.transactions]: "લેવડદેવડ",
  [LangKeys.net_sale]: "શુદ્ધ વેચાણ",
  [LangKeys.unpaid_balance]: "બાકી રકમ",
  [LangKeys.sales_report_share_text]: "આ રહ્યો તમારો વેચાણ રિપોર્ટનો સારાંશ.",

  // PURCHASE REPORT SCREEN
  [LangKeys.purchase_report]: "ખરીદી રિપોર્ટ",
  [LangKeys.net_purchase]: "શુદ્ધ ખરીદી",
  [LangKeys.purchase_report_share_text]: "આ રહ્યો તમારો ખરીદી રિપોર્ટનો સારાંશ.",

  // KHATA FILTER & SORT
  [LangKeys.filter_by_balance]: "બેલેન્સ મુજબ ફિલ્ટર",
  [LangKeys.filter_all_parties]: "બધી પાર્ટીઓ",

  // LOGOUT
  [LangKeys.logout_confirm]: "શું તમે ખરેખર લોગઆઉટ કરવા માંગો છો?",
  [LangKeys.confirm_logout]: "લોગઆઉટ",

  // DEVICES
  [LangKeys.manage_devices]: "ડિવાઇસ મેનેજ કરો",
  [LangKeys.active_devices]: "સક્રિય ડિવાઇસ",
  [LangKeys.logout_device]: "ડિવાઇસ લોગઆઉટ",
  [LangKeys.logout_device_confirm]: "શું તમે આ ડિવાઇસને લોગઆઉટ કરવા માંગો છો?",
  [LangKeys.device_logged_out]: "ડિવાઇસ સફળતાપૂર્વક લોગઆઉટ થઈ ગયું",
  [LangKeys.no_active_devices]: "કોઈ સક્રિય ડિવાઇસ નથી",
  [LangKeys.last_login]: "છેલ્લો લોગિન",
  [LangKeys.this_device]: "આ ડિવાઇસ",
  [LangKeys.loading_devices]: "ડિવાઇસ લોડ થઈ રહ્યા છે...",

  // SMS SETTINGS
  [LangKeys.send_whatsapp_messages]: "વોટ્સએપ મેસેજ મોકલવા",
  [LangKeys.enabled]: "ચાલુ",
  [LangKeys.disabled]: "બંધ",
  [LangKeys.manage_whatsapp_settings]: "વોટ્સએપ SMS સેટિંગ્સ મેનેજ કરો",
  [LangKeys.recharge_and_control]: "ક્રેડિટ રિચાર્જ કરો અને મેસેજ કંટ્રોલ કરો",

  [LangKeys.wa_message_failed]: "સંદેશ મોકલી શકાયો નહીં",
  [LangKeys.wa_no_credits]: "ક્રેડિટ પૂરા થઈ ગયા, સંદેશ મોકલાયો નથી",

  // DASHBOARD EMPTY STATE
  [LangKeys.pro_tip]: "પ્રો ટીપ",
  [LangKeys.dashboard_empty_tip]: "સંપૂર્ણ વિગતો જોવા, સંપાદિત કરવા અથવા ગ્રાહકો સાથે શેર કરવા માટે ડાબી બાજુની કોઈપણ એન્ટ્રી પર ક્લિક કરો.",
  [LangKeys.select_entry]: "એન્ટ્રી પસંદ કરો",
  [LangKeys.entry_details_appear]: "એન્ટ્રીની વિગતો અહીં દેખાશે",

  // PREMIUM
  [LangKeys.plan_standard_name]: "સ્ટાન્ડર્ડ (જાહેરાત મુક્ત)",
  [LangKeys.plan_ads_free_name]: "જાહેરાત મુક્ત +",
  [LangKeys.plan_premium_name]: "પ્રીમિયમ",
  [LangKeys.plan_recommended_tag]: "ભલામણ કરેલ પ્લાન",
  [LangKeys.plan_duration_30_days]: "30 દિવસ માટે",
  [LangKeys.plan_duration_180_days]: "180 દિવસ (6 મહિના) માટે",
  [LangKeys.plan_duration_365_days]: "365 દિવસ (1 વર્ષ) માટે",
  [LangKeys.plan_duration_30_days_badge]: "30 દિવસ",
  [LangKeys.plan_save_20_percent]: "બચત ~20%",
  [LangKeys.plan_best_value_badge]: "શ્રેષ્ઠ મૂલ્ય",
  [LangKeys.plan_best_value_plan_tag]: "શ્રેષ્ઠ મૂલ્ય પ્લાન",
  [LangKeys.plan_most_popular_save]: "સૌથી લોકપ્રિય • ₹{amount} ની બચત",
  [LangKeys.plan_save_amount_tag]: "₹{amount} ની બચત",
  [LangKeys.duration_1_month]: "1 મહિનો",
  [LangKeys.duration_6_months]: "6 મહિના",
  [LangKeys.duration_12_months]: "12 મહિના",
  [LangKeys.plan_save_text]: "બચત",
  [LangKeys.benefit_no_ads]: "જાહેરાત-મુક્ત અનુભવ (100% જાહેરાત મુક્ત)",
  [LangKeys.benefit_support]: "24/7 પ્રાથમિકતા ગ્રાહક સપોર્ટ",
  [LangKeys.benefit_all_ads_free]: "Ads Free + પ્લાનના તમામ લાભો",
  [LangKeys.benefit_multiple_devices]: "એક સાથે બહુવિધ ઉપકરણોમાં લોગિન",
  [LangKeys.benefit_desktop_access]: "કમ્પ્યુટર/ડેસ્કટોપ પર પ્રવેશ",
  [LangKeys.benefit_create_bills]: "બિલ બનાવો (સામાન્ય, જીએસટી બિલ)",
  [LangKeys.benefit_defaulters_list]: "એક ક્લિકમાં ડિફોલ્ટર્સની યાદી જુઓ",
  [LangKeys.benefit_organize_lists]: "યાદીઓ સાથે ખાતાઓને વ્યવસ્થિત કરો",
  [LangKeys.benefit_manage_stocks]: "સ્ટોક મેનેજ કરો (વ્યવહારો સાથેની આઇટમ્સ)",
  [LangKeys.benefit_financial_reports]: "પ્રીમિયમ નાણાકીય અહેવાલો (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "સુરક્ષિત સ્થાનિક અને ક્લાઉડ બેકઅપ",
  [LangKeys.benefit_unlimited_entry]: "કેશબુક/ખાતામાં અમર્યાદિત એન્ટ્રીઓ",
  [LangKeys.benefit_unlimited_transactions]: "અમર્યાદિત વ્યવહારો (Unlimited Transactions)",
  [LangKeys.benefit_unlimited_sms]: "અમર્યાદિત વ્યવહાર SMS",
  [LangKeys.benefit_dairy_management]: "ડેરી ફીચર્સ (દૂધ રેકોર્ડ, રેટ ચાર્ટ, બિલ)",
  [LangKeys.benefit_refer_earn]: "રેફર કરો અને કમાઓ (ફ્રી રિચાર્જ માન્યતા)",
  [LangKeys.my_subscription_title]: "મારું સબ્સ્ક્રિપ્શન",
  [LangKeys.premium_plans_title]: "અમારા પ્રીમિયમ પ્લાન",
  [LangKeys.active_badge_label]: "સક્રિય",
  [LangKeys.expires_on_label]: "{date} ના રોજ સમાપ્ત થશે",
  [LangKeys.expired_badge_label]: "સમાપ્ત",
  [LangKeys.expired_on_label]: "{date} ના રોજ સમાપ્ત થઈ ગયું",
  [LangKeys.extend_plan_label]: "પ્લાન લંબાવો (+{days} દિવસ)",
  [LangKeys.days_remaining_label]: "({days} દિવસ બાકી)",
  [LangKeys.secure_checkout_label]: "100% સલામત અને સુરક્ષિત SSL ચેકઆઉટ",
  [LangKeys.upgrade_button]: "અપગ્રેડ કરો",
  [LangKeys.downgrade_button]: "પ્લાન ડાઉનગ્રેડ કરો",

  // REPORTS DASHBOARD
  [LangKeys.business_reports]: "વ્યાવસાયિક અહેવાલો",
  [LangKeys.business_reports_desc]: "તમારા વ્યવસાય માટે વિશ્લેષણ અને સૂઝ",
  [LangKeys.ledger_cashbook_reports]: "લેજર અને કેશબુક અહેવાલો",
  [LangKeys.billing_inventory_reports]: "બિલિંગ અને ઇન્વેન્ટરી અહેવાલો",
  [LangKeys.customer_ledger_statement_report]: "ગ્રાહક ખાતાવહી પત્રક",
  [LangKeys.customer_ledger_report_desc]: "ગ્રાહકો માટે વિગતવાર લેવડદેવડનો ઇતિહાસ અને બેલેન્સ",
  [LangKeys.supplier_ledger_statement_report]: "સપ્લાયર ખાતાવહી પત્રક",
  [LangKeys.supplier_ledger_report_desc]: "સપ્લાયર્સ માટે વિગતવાર લેવડદેવડનો ઇતિહાસ અને બેલેન્સ",
  [LangKeys.cashbook_report_desc]: "રોકડ/ઓનલાઇન એન્ટ્રીઓ માટે સંપૂર્ણ ડેબુક અને પેમેન્ટ મોડ પત્રક",
  [LangKeys.sales_report_desc]: "બિલ-વાર વેચાણ સારાંશ, કુલ વેચાણ અને બાકી રકમ",
  [LangKeys.purchase_report_desc]: "બિલ-વાર ખરીદીના રેકોર્ડ અને સારાંશ",
  [LangKeys.bills_summary_report]: "બિલ સારાંશ અહેવાલ",
  [LangKeys.bills_summary_report_desc]: "વેચાણ, ખરીદી અને નફા-નુકસાનની ગણતરીની ઝાંખી",
  [LangKeys.item_stock_sales_report]: "આઇટમ સ્ટોક અને વેચાણ અહેવાલ",
  [LangKeys.item_stock_sales_report_desc]: "ઉત્પાદનો અને સેવાઓ માટે વેચાણ અને સ્ટોક-ઇન/આઉટ સારાંશ",
  [LangKeys.select_party]: "પાર્ટી પસંદ કરો",
  [LangKeys.search_placeholder]: "નામ અથવા મોબાઇલ દ્વારા શોધો...",
  [LangKeys.back_to_dashboard]: "રિપોર્ટ મેનૂ પર પાછા જાઓ",
  [LangKeys.loading_report_data]: "રિપોર્ટ ડેટા લોડ થઈ રહ્યો છે...",
  [LangKeys.no_parties_found]: "કોઈ પાર્ટી મળી નથી.",
  [LangKeys.select_customer]: "રિપોર્ટ જોવા માટે ગ્રાહક પસંદ કરો",
  [LangKeys.select_supplier]: "રિપોર્ટ જોવા માટે સપ્લાયર પસંદ કરો",
  [LangKeys.premium_feature]: "પ્રીમિયમ ફીચર",
  [LangKeys.premium_lock_desc]: "પ્રોફેશનલ બિલિંગ, સેલ્સ/પર્ચેઝ ઇન્વોઇસ રિપોર્ટ્સ, ડેબુક સ્ટેટમેન્ટ્સ અને ઇન્વેન્ટરી સારાંશ અનલૉક કરો.",
  [LangKeys.upgrade_to_premium]: "જાહેરાત મુક્ત+ / પ્રીમિયમ પર અપગ્રેડ કરો 🚀",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'ઓનલાઇન સ્ટોર સેટિંગ્સ (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'ઓનલાઇન બિઝનેસ ચાલુ રાખો',
  [LangKeys.biz_profile__online_business_active]: 'બિઝનેસ ઓનલાઇન સક્રિય છે (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'બિઝનેસ ઓનલાઇન બંધ છે (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'ઓનલાઇન સક્રિય છે (GPS સેટ કરો)',
  [LangKeys.biz_profile__online_business_sub_active]: 'ચાલુ કર્યા પછી 1-ક્લિકમાં રાજ્ય, જિલ્લો, વિસ્તાર અને પિનકોડ ભરો અને GPS સ્થાન સેટ કરો, જેથી તમારી દુકાન ગ્રાહકોને દેખાય.',
  [LangKeys.biz_profile__online_business_sub_offline]: 'બિઝનેસને ઓનલાઇન ચાલુ કરો જેથી આસપાસના ગ્રાહકો લોકલ માર્કેટમાં તમારા ઉત્પાદનો અને સેવાઓ શોધી શકે.',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 ફાયદા અને નિયમો જાણો',
  [LangKeys.biz_profile__benefits_modal_title]: 'ઓનલાઇન બિઝનેસના ફાયદા અને સંપૂર્ણ માહિતી',
  [LangKeys.biz_profile__benefits_step1_title]: '1. આ ચાલુ કરવાથી શું થશે?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'તમારો બિઝનેસ, ઉત્પાદનો અને સેવાઓ તરત જ લોકલ માર્કેટમાં લાઇવ થઈ જશે. આસપાસના તમામ ગ્રાહકો તમને શોધી શકશે.',
  [LangKeys.biz_profile__benefits_step2_title]: '2. તમારે શું કરવાનું છે?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• વાદળી બટન (⚡ 1-ક્લિક) થી રાજ્ય, જિલ્લો, વિસ્તાર, પિનકોડ અને GPS સેટ કરો.\n• તમારા ઉત્પાદનો કે સેવાઓ ઉમેરો.',
  [LangKeys.biz_profile__benefits_step3_title]: '3. આનાથી શું ફાયદા મળશે?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% કમિશન (100% મફત) — કોઈ વચેટિયો નહીં.\n• ગ્રાહકો પાસેથી સીધા WhatsApp અને કૉલ પર ઓર્ડર મેળવો.\n• 24 કલાક ખુલ્લો ડિજિટલ બિઝનેસ.',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'સમજાઈ ગયું, આભાર 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-ક્લિકમાં પૂરું સરનામું ઑટો ભરો',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS થી રાજ્ય, જિલ્લો, ગામ અને પિનકોડ આપમેળે ભરો',
  [LangKeys.biz_profile__autofill_searching]: 'સ્થાન શોધાઈ રહ્યું છે...',
  [LangKeys.biz_profile__state_lbl]: 'રાજ્ય (State)',
  [LangKeys.biz_profile__state_add]: 'રાજ્ય ઉમેરો',
  [LangKeys.biz_profile__state_placeholder]: 'દા.ત. Gujarat, Rajasthan...',
  [LangKeys.biz_profile__city_lbl]: 'શહેર / જિલ્લો (City / District)',
  [LangKeys.biz_profile__city_add]: 'શહેર ઉમેરો',
  [LangKeys.biz_profile__city_placeholder]: 'દા.ત. Ahmedabad, Surat, Rajkot...',
  [LangKeys.biz_profile__area_lbl]: 'ગામ / વિસ્તાર (Area / Village)',
  [LangKeys.biz_profile__area_add]: 'ગામ/વિસ્તાર ઉમેરો',
  [LangKeys.biz_profile__area_placeholder]: 'દા.ત. Navrangpura, Bapunagar...',
  [LangKeys.biz_profile__pincode_lbl]: 'પિનકોડ (Pincode)',
  [LangKeys.biz_profile__pincode_add]: 'પિનકોડ ઉમેરો',
  [LangKeys.biz_profile__pincode_placeholder]: '6 અંકનો પિનકોડ દાખલ કરો',
  [LangKeys.biz_profile__tagline_lbl]: 'બિઝનેસની ટેગલાઇન/વર્ણન',
  [LangKeys.biz_profile__tagline_add]: 'ટેગલાઇન ઉમેરો',
  [LangKeys.biz_profile__tagline_placeholder]: 'દા.ત. અમારા અહીં તાજી અને શુદ્ધ ચીજવસ્તુઓ મળે છે',
  [LangKeys.biz_profile__gps_lbl]: 'બિઝનેસનું GPS સ્થાન',
  [LangKeys.biz_profile__gps_not_set]: 'સ્થાન હજી સેટ નથી',
  [LangKeys.biz_profile__gps_update_btn]: 'અપડેટ કરો',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS સ્થાન મેળવો',
  [LangKeys.biz_profile__gps_searching]: 'શોધી રહ્યાં છીએ...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ સ્ટોર ઓનલાઇન છે પણ GPS સેટ નથી! કૃપા કરીને ⚡ 1-ક્લિક બટનથી GPS સેટ કરો જેથી ગ્રાહકોને દુકાન દેખાય.',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'કૃપા કરીને બ્રાઉઝર/ફોનનું GPS સ્થાન ચાલુ કરો',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'સ્થાનની પરવાનગી નકારવામાં આવી',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'કૃપા કરીને સેટિંગ્સમાં જઈને Location Permission ચાલુ કરો',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS થી પૂરું સરનામું આપમેળે ભરાઈ ગયું!',
  [LangKeys.biz_profile__gps_error_toast]: 'સ્થાન મેળવવામાં ભૂલ',
  [LangKeys.biz_market_video_guide_title]: 'લોકલ માર્કેટમાં દુકાન ઓનલાઇન કેવી રીતે કરવી?',
  [LangKeys.biz_market_video_guide_sub]: '1 મિનિટનો વિડિયો જુઓ અને શીખો • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "સ્ટોર અને પ્રોડક્ટ ઓનલાઇન એક્ટિવ કરવાની ગાઇડ",
  [LangKeys.service_video_guide_btn_sub]: "કામ અને દુકાન ઓનલાઇન એક્ટિવ કરવાની ગાઇડ",
  [LangKeys.item_marketplace_title]: "ઓનલાઇન બજાર (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "આ પ્રોડક્ટ આસપાસના ગ્રાહકોને ઓનલાઈન દેખાશે, તેઓ તમારો સીધો સંપર્ક કરી શકશે અને WhatsApp પર ઓર્ડર કરી શકશે.",
  [LangKeys.item_marketplace_sub_inactive]: "આ પ્રોડક્ટ ફક્ત તમારા ખાનગી ખાતામાં રહેશે.",
  [LangKeys.service_marketplace_sub_active]: "આ સેવા આસપાસના ગ્રાહકોને ઓનલાઈન દેખાશે, તેઓ તમારો સીધો સંપર્ક કરી શકશે અને WhatsApp/કૉલ પર બુકિંગ કરી શકશે.",
  [LangKeys.service_marketplace_sub_inactive]: "આ સેવા ફક્ત તમારી દુકાન/પેઢીના ખાનગી ખાતામાં રહેશે.",
  [LangKeys.item_category_lbl]: "કેટેગરી (Category)",
  [LangKeys.change_btn]: "બદલો",
  [LangKeys.item_discount_price_lbl]: "ઓફર / ડિસ્કાઉન્ટ ભાવ (₹) (વૈકલ્પિક)",
  [LangKeys.item_discount_price_hint]: "દા.ત. 450",
  [LangKeys.service_discount_price_lbl]: "ઓફર / ડિસ્કાઉન્ટ સર્વિસ ચાર્જ (₹) (વૈકલ્પિક)",
  [LangKeys.service_discount_price_hint]: "દા.ત. 750",
  [LangKeys.item_desc_lbl]: "વિગત (Short Description) (વૈકલ્પિક)",
  [LangKeys.item_desc_hint]: "પ્રોડક્ટનું બ્રાન્ડ, મોડલ, કલર, સાઇઝ અને મુખ્ય ફીચર્સ લખો (ગૂગલ સર્ચમાં મદદ મળશે)...",
  [LangKeys.service_desc_lbl]: "સર્વિસની વિગત (Description) (વૈકલ્પિક)",
  [LangKeys.service_desc_hint]: "સેવાના મુખ્ય ફીચર્સ, કાર્યપદ્ધતિ અને અનુભવ લખો (ગૂગલ સર્ચમાં મદદ મળશે)...",
  [LangKeys.market_seo_badge]: "ગૂગલ સર્ચ અને રેન્કિંગ",
  [LangKeys.category_picker_title]: "કેટેગરી પસંદ કરો (Select Category)",
  [LangKeys.category_picker_sub_item]: "સામાન કઈ શ્રેણી/વેપારનો છે?",
  [LangKeys.category_picker_sub_service]: "સર્વિસ કઈ શ્રેણી/કાર્યની છે?",
  [LangKeys.category_search_hint]: "કેટેગરી શોધો (દા.ત. કરિયાણું, દૂધ, કપડાં...)",
  [LangKeys.no_category_found]: "કોઈ કેટેગરી મળી નથી",
  [LangKeys.nothing_found_for]: "માટે કંઈ મળ્યું નથી",
  [LangKeys.cat_title_general]: "સામાન્ય ઉત્પાદનો",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "કરિયાણું, રાશન અને પ્રોવિઝન",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "ડેરી, દૂધ, ઘી અને પનીર",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "ફળો અને તાજા શાકભાજી",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "મીઠાઈ, ફરસાણ અને બેકરી",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "હોટેલ, ધાબા અને રેસ્ટોરન્ટ",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "મેડિકલ, દવાઓ અને હેલ્થકેર",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "કૃષિ, ખાતર, બિયારણ અને જંતુનાશક",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "પશુ આહાર, ખોળ અને ફીડ",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "મોબાઈલ, લેપટોપ અને કોમ્પ્યુટર",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "ઇલેક્ટ્રિકલ્સ અને હોમ એપ્લાયન્સિસ",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "કપડાં, સાડી અને રેડીમેડ",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "પગરખાં, ચંપલ અને શૂઝ",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "હાર્ડવેર, સેનિટરી અને સાધનો",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "બિલ્ડિંગ મટિરિયલ અને સિમેન્ટ",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "ઓટો પાર્ટ્સ અને સ્પેરપાર્ટ્સ",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "કોસ્મેટિક્સ, બ્યુટી અને સલૂન",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "પુસ્તકો, સ્ટેશનરી અને પ્રિન્ટિંગ",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "સોનું-ચાંદી અને જ્વેલરી",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "ફર્નિચર અને હોમ ડેકોર",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "વાસણો અને કિચનવેર",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "રમકડાં અને સ્પોર્ટ્સ",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "પ્લાસ્ટિક અને ડિસ્પોઝેબલ સામાન",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "ટેલરિંગ અને બુટિક",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "માંસ, માછલી અને પોલ્ટ્રી",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "રિપેરિંગ અને મિસ્ત્રી સેવા",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "અન્ય તમામ સામાન અને સેવાઓ",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "ચશ્મા અને ઓપ્ટિકલ્સ",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "પૂજા સામગ્રી અને અગરબત્તી",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "ઘડિયાળ અને એક્સેસરીઝ",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "સામાન્ય સેવા (General Service)",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "ટીવી, LED અને ઇલેક્ટ્રોનિક્સ રિપેરિંગ",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "એસી, ફ્રિજ, વોશિંગ મશીન અને ગીઝર",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "ઇલેક્ટ્રિશિયન, વાયરિંગ અને પંખા",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "પ્લમ્બર, પાઇપ અને સેનિટરી ફિટિંગ",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "સિલાઈ, ટેલરિંગ અને બુટિક",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "મોબાઈલ, લેપટોપ અને કોમ્પ્યુટર રિપેર",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "કાર, બાઇક, ઓટો સર્વિસ અને વોશિંગ",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "બ્યુટી પાર્લર, સલૂન અને મેકઓવર",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "સુથાર / કારપેન્ટર અને લાકડાનું કામ",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "પેઇન્ટિંગ, પુટ્ટી અને કલરકામ",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "મકાન બાંધકામ, કોન્ટ્રાક્ટર અને મિસ્ત્રી",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "ટ્રેક્ટર, બોરવેલ અને મોટર સર્વિસ",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "સીસીટીવી અને સિક્યુરિટી ઇન્સ્ટોલેશન",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "ક્લિનિંગ, વોટર ટેન્ક અને પેસ્ટ કંટ્રોલ",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "ટ્રાન્સપોર્ટ, લોડિંગ અને શિફ્ટિંગ",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "ફોટોગ્રાફી અને વિડિયોગ્રાફી",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "ટેન્ટ હાઉસ, કેટરિંગ, ડીજે અને સાઉન્ડ",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "કોચિંગ, ટ્યુશન અને ક્લાસિસ",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "CA, ટેક્સ અને ઇ-મિત્ર સેવા",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "ડોક્ટર, ક્લિનિક અને લેબ ટેસ્ટ",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "અન્ય તમામ સેવાઓ અને કારીગરી",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "ટેક્સી અને ટૂર ટ્રાવેલ્સ",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "વકીલ અને કાનૂની સલાહ",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "પેકર્સ એન્ડ મૂવર્સ",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "પ્રિન્ટિંગ અને ફ્લેક્સ બેનર",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "જિમ, ફિટનેસ અને યોગ",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "રસોઈયા અને ઘરકામ સહાયક",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "ફોટો ઉમેરાયો • Tier-1 ટોપ લિસ્ટિંગ",
  [LangKeys.item_photo_guide_why_add]: "ફોટો કેમ ઉમેરવો? (5x વધુ વેચાણ)",
  [LangKeys.service_photo_guide_why_add]: "ફોટો કેમ ઉમેરવો? (5x વધુ બુકિંગ)",
  [LangKeys.item_photo_guide_desc]: "સ્પષ્ટ અને સારી ગુણવત્તાવાળા PNG/JPG ફોટા ઉમેરો. ફોટોવાળા ઉત્પાદનો લોકલ માર્કેટમાં સૌથી ઉપર (Tier-1) દેખાય છે.",
  [LangKeys.service_photo_guide_desc]: "તમારા કામ, ટૂલ્સ અથવા દુકાનના સ્પષ્ટ PNG/JPG ફોટા ઉમેરો. ફોટોવાળી સેવાઓ નજીકના ગ્રાહકોને સૌથી ઉપર (Tier-1) દેખાય છે.",
  [LangKeys.item_video_guide_btn_title]: "ઓનલાઇન લિસ્ટિંગ શીખો (5 મિનિટ વીડિયો)",
  [LangKeys.service_video_guide_btn_title]: "સર્વિસ લિસ્ટિંગ શીખો (5 મિનિટ વીડિયો)",
  [LangKeys.market_format_bold]: "𝗕 બોલ્ડ (*નામ*)",
  [LangKeys.market_format_bullet]: "• બુલેટ પોઇન્ટ",
  [LangKeys.market_format_highlight]: "⭐ મુખ્ય વિશેષતા",
  [LangKeys.market_format_warranty_item]: "📦 વોરંટી / વિગતો",
  [LangKeys.market_format_warranty_service]: "📦 વોરંટી / ગેરંટી",
  [LangKeys.market_format_template_item]: "⚡ તૈયાર બ્લોગ ટેમ્પલેટ",
  [LangKeys.market_format_template_service]: "⚡ તૈયાર સર્વિસ ટેમ્પલેટ",
  [LangKeys.market_seo_tip_item]: "વિગતવાર વર્ણન લખવાથી તમારી પ્રોડક્ટ ગૂગલ સર્ચ અને ઓનલાઇન માર્કેટમાં ઝડપથી ગ્રાહકોને દેખાશે.",
  [LangKeys.market_seo_tip_service]: "વિગતવાર વર્ણન લખવાથી તમારી સેવા ગૂગલ સર્ચ અને ઓનલાઇન માર્કેટમાં ઝડપથી ગ્રાહકોને દેખાશે.",
  [LangKeys.crop_photo_title]: "ફોટો ક્રોપ અને એડજસ્ટ કરો",
  [LangKeys.crop_product_photo]: "પ્રોડક્ટ ફોટો ક્રોપ અને એડજસ્ટ કરો",
  [LangKeys.crop_service_photo]: "સર્વિસ ફોટો ક્રોપ અને એડજસ્ટ કરો",
  [LangKeys.crop_drag_hint]: "આંગળી અથવા માઉસથી ફોટો ખસેડો / ડ્રેગ કરો",
  [LangKeys.crop_rotate_left]: "90° ડાબે",
  [LangKeys.crop_rotate_right]: "90° જમણે",
  [LangKeys.crop_reset]: "રીસેટ",
  [LangKeys.crop_ratio_square]: "1:1 (ચોરસ)",
  [LangKeys.crop_ratio_standard]: "4:3 (સ્ટાન્ડર્ડ)",
  [LangKeys.crop_ratio_free]: "Free (મુક્ત)",
  [LangKeys.crop_save_done]: "ક્રોપ અને સેવ કરો (Done)",
  [LangKeys.crop_compressing]: "કમ્પ્રેસ થઈ રહ્યું છે...",
  [LangKeys.party_or_details]: "પાર્ટી / વિગતો",
  [LangKeys.report_copied_clipboard]: "રિપોર્ટની વિગતો ક્લિપબોર્ડ પર કૉપિ થઈ ગઈ છે!",
  [LangKeys.party]: "પાર્ટી",
  [LangKeys.sale]: "વેચાણ",
  [LangKeys.purchase]: "ખરીદી",
  [LangKeys.expense]: "ખર્ચ",
  [LangKeys.ai_support_btn]: "AI સપોર્ટ સાથે તરત ચેટ કરો (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI સપોર્ટ",
  [LangKeys.ai_support_online_status]: "● 24x7 તાત્કાલિક સહાય",
  [LangKeys.ai_support_welcome_msg]: "નમસ્તે! 🙏 હું *Moxpal Khata* નો સ્માર્ટ AI સહાયક છું.\\n\\nહું તમારા ખાતા, બિલિંગ, ડેરી પાસબુક અથવા સબ્સ્ક્રિપ્શન પ્લાન સંબંધિત તમામ પ્રશ્નોમાં મદદ કરવા માટે તૈયાર છું. તમે શું જાણવા માગો છો?",
  [LangKeys.ai_support_input_hint]: "તમારો પ્રશ્ન અથવા સમસ્યા અહીં પૂછો...",
  [LangKeys.ai_support_typing]: "AI સહાયક જવાબ લખી રહ્યો છે...",
  [LangKeys.ai_support_copied]: "સંદેશ કૉપિ થયો",
  [LangKeys.ai_support_net_error]: "ઇન્ટરનેટ કનેક્શનમાં સમસ્યા છે. કૃપા કરીને નેટવર્ક તપાસો.",
  [LangKeys.ai_support_server_error]: "સર્વર સાથે જોડાવામાં સમસ્યા થઈ. કૃપા કરીને ફરી પ્રયાસ કરો અથવા WhatsApp પર સંપર્ક કરો.",
  [LangKeys.ai_support_sugg_plan]: "💎 પ્લાનના શું ફાયદા છે?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 ડેરી પાસબુક કેવી રીતે વાપરવી?",
  [LangKeys.ai_support_sugg_party]: "👥 નવો ગ્રાહક/ખાતું કેવી રીતે ઉમેરવું?",
  [LangKeys.ai_support_sugg_backup]: "💾 ડેટા બેકઅપ કેવી રીતે લેવો?",
  [LangKeys.ai_support_sugg_bill]: "🧾 નવું બિલ કેવી રીતે બનાવવું?",
  [LangKeys.ai_support_clear_chat]: "નવી વાતચીત શરૂ કરો",
  [LangKeys.ai_support_clear_title]: "ચેટ ઇતિહાસ સાફ કરવો છે?",
  [LangKeys.ai_support_clear_confirm]: "શું તમે જૂની વાતચીત સાફ કરીને નવી ચેટ શરૂ કરવા માગો છો?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "વારંવાર પૂછાતા પ્રશ્નો, ટ્યુટોરિયલ્સ અને ગ્રાહક સપોર્ટ માટેનું કેન્દ્ર",
  [LangKeys.help_support_title]: "મદદ અને સપોર્ટ",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "FAQs, ટ્યુટોરિયલ્સ અને ગ્રાહક સપોર્ટ માટે તમારું વન-સ્ટોપ સેન્ટર",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 ત્વરિત સપોર્ટ",
  [LangKeys.help_ai_desc]: "ખાતા, બિલિંગ, ઇન્વેન્ટરી, ડેરી પાસબુક અથવા પ્લાન સંબંધિત તમામ પ્રશ્નોના ત્વરિત AI ઉકેલો મેળવો.",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • સત્તાવાર સપોર્ટ ટીમ",
  [LangKeys.help_call_title]: "કોલ હેલ્પલાઇન",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "ઇમેઇલ સપોર્ટ",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "વારંવાર પૂછાતા પ્રશ્નો (FAQs)",
  [LangKeys.help_faq_1_q]: "ખાતામાં નવા ગ્રાહક અથવા વેપારીને કેવી રીતે ઉમેરવા?",
  [LangKeys.help_faq_1_a]: "હોમ સ્ક્રીન પર \"Add Customer\" બટન દબાવો, નામ અને મોબાઇલ નંબર દાખલ કરો અને સાચવો.",
  [LangKeys.help_faq_2_q]: "ડેરી પાસબુકમાં દૂધ સંગ્રહની એન્ટ્રી કેવી રીતે કરવી?",
  [LangKeys.help_faq_2_a]: "ડેરી વિભાગમાં જાઓ, \"દૂધ એન્ટ્રી\" પસંદ કરો, ફેટ/SNF અથવા સીધો રેટ દાખલ કરીને 1-ક્લિકમાં રસીદ મોકલો.",
  [LangKeys.help_faq_3_q]: "ડેટા બેકઅપ કેવી રીતે સુરક્ષિત રહે છે?",
  [LangKeys.help_faq_3_a]: "મોક્ષપાલ ખાતા પર તમારો તમામ ડેટા ક્લાઉડ સર્વર પર 100% એન્ક્રિપ્ટેડ અને સુરક્ષિત રહે છે.",
  [LangKeys.help_faq_4_q]: "સબ્સ્ક્રિપ્શન પ્લાન કેવી રીતે અપગ્રેડ કરવો?",
  [LangKeys.help_faq_4_a]: "સેટિંગ્સમાં \"મારું સબ્સ્ક્રિપ્શન\" પર જાઓ અને તમારો મનપસંદ પ્લાન પસંદ કરીને સુરક્ષિત પેમેન્ટ કરો.",
  [LangKeys.help_footer_call_hours]: "કોલ સપોર્ટ: સોમ - શનિ (સવારે 9:00 થી રાત્રે 8:00)",
  [LangKeys.help_footer_ai_hours]: "AI ચેટ સહાયક: 24 કલાક 365 દિવસ ત્વરિત સહાય",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% સુરક્ષિત અને વિશ્વસનીય • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "સુવિધા ખોલવામાં અસમર્થ",
};

export default gu;